import React, { Component, Fragment } from "react";
import { Howl } from "howler";
import { Stage, Layer, Group, Rect, Arc, Text } from "react-konva";
import Tiepannel from "././../../../../../assets/games/Baccarat/tie.svg"
import Banker_pannel from "././../../../../../assets/games/Baccarat/Banker.svg"
import Player_pannel from "././../../../../../assets/games/Baccarat/Player.svg"
import playerglow from "././../../../../../assets/games/Baccarat/glowbaccart_pannel.png"
import optionbtnwindows from "../../../../../assets/games/russianPoker/optionbtnwindows.png";
import betbutton_baccartimg from "././../../../../../assets/games/CarebbeanPoker/betbtn.png";
import clear_baccartimg from "././../../../../../assets/games/CarebbeanPoker/foldbtnwindows.png";
import undobuttonbaccart from "././../../../../../assets/games/CarebbeanPoker/buybtnwindows.png"
import useridlmg from "../../../../../assets/games/russianPoker/userid.png";
import balanceiconwindows from "../../../../../assets/games/russianPoker/balancewindows.png";
import volumeimg from "../../../../../assets/games/russianPoker/Valume.png";
import beticonwindows from "../../../../../assets/games/russianPoker/betwindows.png";
import winnericnwindows from "../../../../../assets/games/russianPoker/winnericonwindows.png";
import baccartdeck from "../../../../../assets/games/russianPoker/dc.png";
// import betchipsnd from "././../../../../../assets/sounds/betoncard.mp3";
// import betrussiansnd from "././../../../../../assets/sounds/bet.mp3";
// import pokerchipsnd from "././../../../../../assets/sounds/pokerchip_snd.mp3";
// import plyerwin_snd from "././../../../../../assets/sounds/playerwin.mp3";
// import cardsdropping_snd from "././../../../../../assets/sounds/carddroping.mp3";
// import cardsshuffle from "././../../../../../assets/sounds/shuffle-cards.mp3";
// import reaveldealer_cards from "././../../../../../assets/sounds/dealercards_reavel.mp3";
// import clear_snd from "././../../../../../assets/sounds/clear.mp3";
// import selectCard from "../../../../../assets/sounds/selectcard.mp3";
// import unselectCard from "../../../../../assets/sounds/unselectcard.mp3";
// import playerWin from "../../../../../assets/sounds/coinBurstwinSound.mp3"
// import playerLose from "../../../../../assets/sounds/successNew.mp3"
import Card from "../Baccarat/UI/Baccaratplayercards";
import chip_10 from "../../../../../assets/games/CarebbeanPoker/black.png";
import chip_25 from "../../../../../assets/games/CarebbeanPoker/Purple-chip.png";
import chip_50 from "../../../../../assets/games/CarebbeanPoker/blue.png";
import chip_100 from "../../../../../assets/games/russianPoker/red.png";
import chip_500 from "../../../../../assets/games/CarebbeanPoker/yellow.png";
import chip_1000 from "../../../../../assets/games/CarebbeanPoker/Whitechip.png";
import volume_baccart from "../../../../../assets/games/CarebbeanPoker/Valume.png";
import infrmicon_baccart from "../../../../../assets/games/CarebbeanPoker/i.png";
import incerementbtn from "../../../../../assets/games/CarebbeanPoker/betincreament&decreament.png";
import decrementbtn from "../../../../../assets/games/CarebbeanPoker/betincreament&decreament.png";
import mutesnds from "../../../../../assets/games/russianPoker/mute_snds.png"
import popupExit from "../../../../../assets/common_imgs/exit_btn.png"
import baccarttable_window from "../../../../../assets/games/Baccarat/Baccarat-1-2-1edit.webp"
import baccarattable_port from "../../../../../assets/games/Baccarat/Baccarat-Mobile-21.webp"
import baccarattable_land from "../../../../../assets/games/Baccarat/Baccarat-Mobile-Landscape.webp"
import WinAnimation from "../../../Utillitys/WinAnimaion"
import gsap from "gsap";
import resultCards_crbn from "./UI/resultCards";
import DealerCardsContainer from "./UI/Baccartdealercardscontainer";
import "./Baccarat.css";
import Howlersounds from "../../../Utillitys/howlersounds";
import { connect } from "react-redux";
import { FaLess } from "react-icons/fa";

// npm i react-konva@17.0.1-3
class Baccarat extends Component {
  constructor(props) {
    super(props);
    this.cardsRef = React.createRef();
    this.Howlersounds = React.createRef();
    this.dealerCardsContainer = React.createRef();
    this.chiprefBaccart = React.createRef();
    this.chiprefbanker = React.createRef();
    this.chiprefTie = React.createRef();
    this.betchipstoantebet = null;
    this.dealerCardsContainer = React.createRef();
    // antebetresult and shuffled result : ---------
    this.randomPlayerCards = [];
    this.shuffledPlayerCards = [];
    this.randomDealerCards = [];
    // replaceCards (userSelectedCards) : ---------
    this.replaceCards = [];
    // serverResponse (after draw cards) : ---------
    this.unsequenceDrawCards = [];
    this.sequenceDrawCards = [];
    // clickOnBuyCard : ---------
    this.buyCardUnsequenceArray = [];
    this.buyCardsequenceArray = [];
    // DEALER CARDS
    this.dealerCardsRandom = [];
    this.dealerShuffledCards = [];
    // CONFIRM_DEALER_CARD : -----------------
    this.dealerUnsequenceDrawCards = [];
    this.dealerSequenceDrawFinalCards = [];
    this.handleResize = this.handleResize.bind(this);
    this.interval = null;
    this.NavigateState = null;
    this.GameRules = [

      { "name": "Baccarat is a popular card game. The goal of this game is to get a point total value as close to 9 as possible over the course of a 2-3 card hand." },
      { "name": "One standard 52 card decks is used in the game. The cards are shuffled prior to each new round. " },
      { "name": "UNDO: If you have not yet confirmed your action, you can undo your last move to reconsider your decision." },
      { "name": `A hand of baccarat begins when all bets have been placed on the desired betting area of the table – “Player”, or “Banker”, or “Tie”. Minimum bet is ${this.props.minBetAmt}, maximum - ${this.props.maxBetAmt}.  ` },
      { "name": "Clicking the “ Bet” button, the Banker and the Player both receive two cards; then they count their points." },
      { "name": "If you choose to play, you should place a BET equal to two times of original Ante. Use “Bet” button to make a bet." },
      { "name": "The values of the cards are as follows:" },
      { "name": "Ace counts as one" },
      { "name": "2 through 9 count according to its number values" },
      { "name": "Face cards and 10 count as zero" },
      { "name": "If total amount of points equals 10 or more, then 10 is subtracted from the it and the remainder is considered as a result of the hand (for example, 7+6=13=3 or 4+6=10=0)" },
      { "name": "The participant (player or Banker) who got 9 points wins. The player who got 8 points is considered as a winner if opponent has less. If neither of participants has 8 or 9 points, the third card is dealt to the player or Banker, or to both of them according to the Third Card Rules. " },
      { "name": "If Tie happens when betting on Player or Banker, the bet returns to the player." },
      { "name": "Bet on Player is paid 1 to 1." },
      { "name": "Bet on Banker is paid 1 to 1 minus 5% of commission." },
      { "name": "Bet on Tie is paid 8 to 1." },
      { "name": "Third Card Rule" },
      { "name": "Third Card Rule governs when the player and/or the banker will automatically be dealt the third card in the game." },

      { "name": "If either player or Banker has the cards total equals to 8 or 9, they both stand (this rule override the others). " },

      { "name": "The card is dealt to the player first, then to Banker." },
      { "name": "If the player does not take a card, the Banker takes card if he has 5 or less points." },
      { "name": "If the player takes a card, the Banker acts as shown in the below." },
      { "name": "Player Hands" },
      { "name": "Total Point of Player First Two Cards: 0-1-2-3-4-5 → Take a card." },
      { "name": "Total Point of Player First Two Cards: 6-7 → Does not take a card." },
      { "name": "Total Point of Player First Two Cards: 8-9 → Does not take a card, the Banker cannot take a card." },
      { "name": "If the player does not take a card, the Banker takes a card if he has 5 or less points. If the player takes a card, the Banker acts as shown below." },
      { "name": "Bankers Hand" },
      { "name": "Bankers First Two Cards Total: 0-1-2 → Always takes a card." },
      { "name": "Banker First Two Cards Total: 3 → Takes card if third player card is 0-1-2-3-4-5-6-7-9; does not take card if it’s 8." },
      { "name": "Banker First Two Cards Total: 4 → Takes card if third player card is 2-3-4-5-6-7; does not take card if it’s 0-1-8-9." },
      { "name": "Banker First Two Cards Total: 5 → Takes card if third player card is 4-5-6-7; does not take card if it’s 0-1-2-3-8-9." },
      { "name": "Banker First Two Cards Total: 6 → Takes card if third player card is 6-7; does not take card if it’s 0-1-2-3-4-5-8-9." },
      { "name": "Banker First Two Cards Total: 7 → Banker always stands." },
      { "name": "Banker First Two Cards Total: 8-9 → Player cannot take a card; Banker cannot take a card." }




    ];

    this.state = {
      bankerscore: "",
      playerscore: "",
      isbaccarat: false,
      showwinanimbaccarat: false,
      isPannelEnabled: false,
      showWinAnimation: false,
      attentiobaccart: "",
      player_glow: false,
      clearrebet2: false,
      betrebet: false,
      chipsbaccartval: null,
      isbetsonpannel: false,
      playeractive: null,
      enebleprevbuttons: false,
      prevstateplayer_bets: 0,
      prevstatebanker_bets: 0,
      prevstatetie_bets: 0,
      scoreplyrbnker: null,
      playerscoretext: null,
      bankerscoretext: null,
      phanddetails_baccarat: null,
      optionsmenubutton: null,
      paytablebcrt: null,
      total_betbaccart: 0,
      betdeductbaccart: 0,
      totalbets_baccart: 0,

      betsting_player: 0,
      betsting_banker: 0,
      betsting_tie: 0,
      winner: "",
      finalwinner: false,
      count: 1,
      totalwinamountbaccart: 0,
      iswinsbaccart: false,
      winamountbaccart: null,
      beticonbaccart: false,
      undobtn_baccart: false,
      clerbtn_baccarat: false,
      clerbuttontn_baccarat: null,
      usericonbaccart: null,
      cleartext_baccart: null,
      popupbet_errbalncebc: null,
      textbets_highbaccart: null,
      attentionbaccart: null,
      exitbtnbaccart: null,
      baccartminmax_bets: null,
      balance_baccarticn: null,
      optionbtnwindows: null,
      bettext_baccart: null,
      chipsbaccart: null,
      userbaccart: null,
      balncebaccart: null,
      totlbetbaccart: null,
      winamount_baccart: null,
      infobaccart: null,
      undotextcss_baccart: null,
      undotex_baccarat: null,
      betbutton_baccart: null,
      winner_iconbaccart: null,
      bet__iconbaccart: null,
      winglowbaccart: null,
      Baccarattable: null,
      bgbaccartport: null,
      chipid: null,
      chipclass: null,
      glowpayerpannel: null,
      baccartdeckcards: null,
      chipref: null,
      isbanker: false,
      isplayer: false,
      isTie: false,
      TiePannel: null,
      BankerPannel: null,
      PlayerPannel: null,
      baccaratbetpannel: null,
      topsection_Baccarat: null,
      payout_bodyubaccrt: null,
      baccaratuser: null,
      //  toppanneltext:null,
      volume_infrmcontainer: null,
      incredecrebtns: null,
      baccaratchipscontainer: null,
      payout_mainhead: null,
      myOrient: "land",
      Bets_tracker: [],
      previousBets: {
        player: [], banker: [], tie: []
      },
      lowBalaceErrorInfo: "",
      ShowGamerules: false,
      ShowHistory: false,
      totalAnteBetAmount: 0,
      betOnBanker: 0,
      betOnTie: 0,
      betshigh_balnce: null,
      keyboardhandle: false,
      betbtncrbn: true,
      dealenable: false,
      disClearBtn: 1,
      disDrawbtn: 1,
      disBuybtn: 1,
      Foldbtn: 1,
      Yesbtn: 1,
      isclickamount: 0,
      Nobtn: 1,
      betBtnValue: 0,
      disBetBtn: 1,
      playerhand_status: "",
      isoptionmenu: false,
      buttontext: "",
      balance_rsp: 0,
      updateBet: 0,
      betdeductions: 0,
      antebetcircle: false,
      betchipincrementbtn: false,
      multibuttonsebledsble: false,
      mutesounds: false,
      totalbet: 0,
      bonusbetamount: 0,
      previousBonusbetamount: 0,
      count: 1,
      insurencetbet: 0,
      pokerranking: "",
      pokerrankingdeler: "",
      storebetchips: [],
      storeantebetchips: [],
      storeBetchipsbanker: [],
      storeBetchipstie: [],
      totalwinRussian: 0,
      betdecreamentbtn: false,
      carebbeanidincrement: 0,
      bsbtn: true,
      anteBetAmount: 0,
      previousAnteBetAmount: 0,
      displayplayerscporepercard: [],
      displaybankerscporepercard: [],
      disablemultibutton: false,
      insurencebtn: false,
      isMobilePortraitLndsp: null,
      betbutton: "DEAL",
      activeScreen: null,
      finalwinnerpopup: false,
      // //GroupProperties
      heightOfLayer: null,
      widthOfLayer: null,
      dealerDistanceFromX: null,
      playerDistanceFromX: null,
      dealerDistanceFromY: null,
      PlayerDistanceFromY: null,
      baccart_history: null,
      // SpriteSheetProps
      revealCard: false,
      infoText: this.props.infoText,
      buydrawCheck: false,
      insurencetbet: 0,
      mobileAntiMaskCovercss: null,
      totalbet_baccart: 0,
      // topsectionBaccarat: [
      //   { src: optionbtnwindows, valuetext: "10" },
      //   { src: useridlmg, valuetext: 1 },
      //   { src: balanceiconwindows, valuetext: this.props.balance },
      //   { src: beticonwindows, valuetext: this.state.total_betbaccart },
      //   { src: winnericnwindows, valuetext: 1 },
      // ],

    };


    this.cardsRef = React.createRef();
    // this.dealerCardsContainer = React.createRef();
    this.buyDealerCardDrawn = React.createRef();
    // this.handleResize = this.handleResize.bind(this);
    this.isMobile = false;
    this.newBet = 0;
    this.tableImg = null;





    this.chipVal = [
      { src: chip_10, key: 1, label: "10", val: 10 },
      { src: chip_25, key: 1, label: "20", val: 20 },
      { src: chip_50, key: 1, label: "50", val: 50 },
      { src: chip_100, key: 1, label: "100", val: 100 },
      { src: chip_500, key: 1, label: "500", val: 500 },
      { src: chip_1000, key: 1, label: "1000", val: 1000 },
      // { src: chip_25, key: 1, val: 1000 },
      // { src: chip_25, key: 1, val: 5000 },
    ];
    // this.topsectionBaccarat = [
    //   { src: optionbtnwindows, valuetext: "10",  },
    //   { src: useridlmg, valuetext: 1, },
    //   { src: balanceiconwindows, valuetext: this.props.balance},
    //   { src: beticonwindows, valuetext: this.state.total_betbaccart},
    //   { src: winnericnwindows, valuetext: 1, },


    // ];
    // this.updatePlayerInfo = this.updatePlayerInfo.bind(this);

  }


  componentDidMount() {
    this.NavigateState = navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform == "Windows"
    gsap.ticker.lagSmoothing(0);
    this.interval = setInterval(() => gsap.ticker.tick(), 500);
    document.getElementById('iospopup').style.display = 'block';
    if (this.props.gameState.response) {
      if (this.props.gameState.response.betAmount > 0) {


        this.setState({ enebleprevbuttons: true })
        setTimeout(() => {

          this.enableprevbetsbuttons(this.props.gameState.response.betString);
        }, 500)
      }
    }
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    this.setState({ lowBalaceErrorInfo: "" })
    this.clearActivesWeDid();


    // if (
    //   navigator.userAgentData &&
    //   navigator.userAgentData.platform &&
    //   navigator.userAgentData.platform == "Windows" || (navigator.userAgent.indexOf("Windows") !== -1)
    // ) {
    //   this.setState({ betpannelcover_baccart: "coverbaccart_windows" })


    // }
    // else {
    //   const isPortrait = window.innerHeight > window.innerWidth;
    //   if (isPortrait) {
    //     this.setState({ betpannelcover_baccart: "coverbaccart_port" })
    //   }
    //   else {
    //     this.setState({ betpannelcover_baccart: "coverbaccart_land" })
    //   }

    // }////////////////////////////..............................................commented on 05-08-25.................................////////////////////////////
    document.addEventListener('keydown', this.handleKeyDownbaccarat);
    // if(this.props.gameState.response.betAmount >0 ){
    // this.setState({enebleprevbuttons:true})
    //   this.enableprevbetsbuttons(this.props.gameState.response.betString);
    // }

    let decreasrDisable = document.getElementById('betdecrementcrbn')
    decreasrDisable.classList.add('baccartopacitybtn')

    if (this.props.baccarat_innerLimits) {

      this.innerLimits = this.props.baccarat_innerLimits.split("|");
      console.log(this.innerLimits)
      for (let t = 0; t < this.innerLimits.length; t++) {
        this.innerLimits[t] = this.innerLimits[t].split("-");
        console.log(this.innerLimits[t])
      }

      //   console.log(this.innerLimits);
      // console.log(this.innerLimits[0][0]);
      // console.log(this.innerLimits[0][1]);
      // console.log(this.innerLimits[1][0]);
      // console.log(this.innerLimits[1][1]);
      // console.log(this.innerLimits[2][0]);
      // console.log(this.innerLimits[2][1]);
    }


    if (this.props.bc_chipValues) {
      let newChips = this.props.bc_chipValues.split(",");
      // console.log(newChips);
      // console.log(newChips.length)
      let lblTxt = "";
      // for (let i = 0; i < newChips.slice(0,6).length; i++) {
      for (let i = 0; i < newChips.length; i++) {
        if (Number(newChips[i]) >= 1000 && Number(newChips[i]) <= 999999) {
          lblTxt = "K"
        } else if (Number(newChips[i]) >= 1000000 && Number(newChips[i]) <= 999999999) {
          lblTxt = "M"
        } else if (Number(newChips[i]) > 999999999) {
          lblTxt = "B"
        }
        this.chipVal[i].val = newChips[i]
        // console.log(this.chipVal[i].val, lblTxt);
        this.checkChipValuebaccart(Number(this.chipVal[i].val), lblTxt, i);
      }

    }

    window.addEventListener("resize", this.handleResize);
    this.handleOrientationChange();
    // this.betchipsnd = new Audio(betchipsnd);
    // this.betrussiansnd = new Audio(betrussiansnd);

    // this.reaveldealer_cards = new Howl({ src: [reaveldealer_cards], html5: true, });

    // this.selectCard = new Audio(selectCard);
    // this.unselectCard = new Audio(unselectCard);
    // this.playerWin = new Audio(playerWin);
    // // this.playerLose = new Audio(playerLose);
    // this.betchipactivated = false;
    // this.pokerchipsnd = this.initializeChipSound();
    // this.betchipsnd = this.initializeBetSound();
    // this.playerWin = this.initializePlayerWinSound();
    // this.playerLose = this.initializePlayerLoseSound();
    const { childRef } = this.props;
    childRef(this);

    let Baccarat_table = document.getElementById("Baccart_Table")
    let Baccarat_bgport = document.getElementById("Baccart_bgport")
    let betpannel_baccart = document.getElementById("betpannel_baccarat")
    let topbaccartpannel = document.getElementById('Baccart_topsection')
    let toppannelcntrbaccart = document.getElementById('toppannel')
    let volumeinformicons = document.getElementById('sound_infromicons')
    let btns_baccarat = document.getElementById('btns_incrementdecrement')
    let baccartchips = document.getElementById('betchipsbaccarat_Container')
    const betchipsBaccarat = document.getElementById("betchipsbaccart");
    const betchipstoantebet = document.getElementById(`baccartbets${this.state.carebbeanidincrement}`);
    const infocontainer_baccart = document.getElementById("infocontainerbaccart");
    const minmaxbet_baccart = document.getElementById("minmaxbetbaccart");
    this.setState({ infoText: this.props.language.baccart_bet })

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

      document.getElementById("playerDealerCardContainer").style.zIndex = -1

      this.setState({

        Baccarattable: "Baccarat_tablewindows",
        baccartminmax_bets: "minmaxbets_windowsbaccart",
        baccaratbetpannel: "bet_pannelbaccartwindows",
        topsection_Baccarat: "topsection_Baccarat",
        baccaratuser: this.state.user,
        // toppanneltext:"topbaccartpanneltext",
        volume_infrmcontainer: "valume_informiconscontainer",
        chipsbaccart: "baccat_chipswindows",
        infobaccart: "windowsinfobaccart",
        baccartdeckcards: "windowsbaccart_deck",
        phanddetails_baccarat: "phandbaccartwindws",
        userbaccart: "username_baccartwindows",
        balncebaccart: "balnce_baccartwindows",
        totlbetbaccart: "totalbets_baccartwindows",
        winamount_baccart: "winamnt_baccartwindows",
        incredecrebtns: "incredecrebtnsbaccart", baccaratchipscontainer: "baccarachpcontainer", carebbeanbetchipstoante: "chiptoplayerbaccarat"
      })
      Baccarat_table.classList.add(this.state.Baccarattable)
      Baccarat_table.classList.add(this.state.baccaratbetpannel)
      topbaccartpannel.classList.add(this.state.topsection_Baccarat)
      // toppannelcntrbaccart.classList.add(this.state.toppanneltext)
      volumeinformicons.classList.add(this.state.volume_infrmcontainer)
      btns_baccarat.classList.add(this.state.incredecrebtns)
      baccartchips.classList.add(this.state.baccaratchipscontainer)
      betchipsBaccarat.classList.add(this.state.chipsbaccart)
      infocontainer_baccart.classList.add(this.state.infobaccart)
      minmaxbet_baccart.classList.add(this.state.baccartminmax_bets)

      // betchipstoantebet.classList.add(this.state.baccaratchipscontainer)
      const chipMap = {
        1: { chip: chip_10, extraClass: "valtext_windows_chip10bcrt chip_10text" },
        2: { chip: chip_25, extraClass: "" },
        3: { chip: chip_50, extraClass: "" },
        4: { chip: chip_100, extraClass: "" },
        5: { chip: chip_500, extraClass: "" },
        6: { chip: chip_1000, extraClass: "" }
      };

      const val0 = document.getElementById("val0");
      val0.className = "valtext_windowsbcrat";
      val0.textContent = this.chipVal[this.state.count - 1]?.label || "";

      if (chipMap[this.state.count]) {
        betchipsBaccarat.src = chipMap[this.state.count].chip;
        if (chipMap[this.state.count].extraClass) {
          val0.classList.add(...chipMap[this.state.count].extraClass.split(" "));
        }
      }
    }


    else {
      document.getElementById("playerDealerCardContainer").style.zIndex = -1
      const isPortrait = window.innerHeight > window.innerWidth;
      let chiptextbaccart
      document.getElementById("betincrenetcrbn").classList.add("addnodropbcrt")
      document.getElementById("betdecrementcrbn").classList.add("addnodropbcrt")
      if (isPortrait) {
        chiptextbaccart = "valtextPortrait_baccart"
        this.setState({
          Baccarattable: "Baccarat_tableportr",
          baccartdeckcards: "baccart_deckport",
          phanddetails_baccarat: "phandbaccartport",
          bgbaccartport: "Baccarat_bgportgame",
          baccartminmax_bets: "minmaxbets_portbaccart",
          baccaratbetpannel: "bet_pannelbaccartport",
          usericonbaccart: "user_baccaticonport",
          userbaccart: "username_baccartport",
          balncebaccart: "balnce_baccartport",
          bet__iconbaccart: "beticonbaccartport",
          infobaccart: "info_baccartport",
          balance_baccarticn: "balance_baccarticnport",
          winner_iconbaccart: "winnericonportbaccart",
          optionbtnwindows: "optionbtnport",

          totlbetbaccart: "totalbets_baccartport",
          winamount_baccart: "winamnt_baccartport",
          topsection_Baccarat: "topsection_Baccaratport", baccaratuser: this.state.user,
          // toppanneltext:"topbaccartpanneltext",
          volume_infrmcontainer: "valume_informiconscontainerport",
          chipsbaccart: "baccat_chipsport",
          incredecrebtns: "incredecrebtnsbaccartport", baccaratchipscontainer: "baccarachpcontainerport", carebbeanbetchipstoante: "chiptoplayerbaccaratport"
        })
        Baccarat_table.classList.add(this.state.Baccarattable)
        Baccarat_bgport.classList.add(this.state.bgbaccartport)
        betpannel_baccart.classList.add(this.state.baccaratbetpannel)
        topbaccartpannel.classList.add(this.state.topsection_Baccarat)
        // toppannelcntrbaccart.classList.add(this.state.toppanneltext)
        volumeinformicons.classList.add(this.state.volume_infrmcontainer)
        btns_baccarat.classList.add(this.state.incredecrebtns)
        baccartchips.classList.add(this.state.baccaratchipscontainer)
        betchipsBaccarat.classList.add(this.state.chipsbaccart)
        // Baccarat_table.classList.add(this.state.Baccarattable)
        // Baccarat_table.classList.add(this.state.baccaratbetpannel)
        // topbaccartpannel.classList.add(this.state.topsection_Baccarat)
        // // toppannelcntrbaccart.classList.add(this.state.toppanneltext)
        // volumeinformicons.classList.add(this.state.volume_infrmcontainer)
        // btns_baccarat.classList.add(this.state.incredecrebtns)
        // baccartchips.classList.add(this.state.baccaratchipscontainer)
        // betchipstoantebet.classList.add(this.state.baccaratchipscontainer)


      }
      else {
        document.getElementById("betincrenetcrbn").classList.add("addnodropbcrt")
        document.getElementById("betdecrementcrbn").classList.add("addnodropbcrt")
        chiptextbaccart = "valtextLandscapebaccart"
        this.setState({
          Baccarattable: "Baccarat_tableland",
          baccartdeckcards: "baccart_decklndspe",

          bgbaccartport: "Baccarat_bglandgame",
          phanddetails_baccarat: "phandbaccartland",
          baccaratbetpannel: "bet_pannelbaccartland",
          usericonbaccart: "user_baccaticonland",
          userbaccart: "username_baccartland",
          balncebaccart: "balnce_baccartland",
          baccartminmax_bets: "minmaxbets_landbaccart",
          totlbetbaccart: "totalbets_baccartland",
          balance_baccarticn: "balance_baccarticnland",
          bet__iconbaccart: "beticonbaccartland",
          winner_iconbaccart: "winnericonlandbaccart",
          optionbtnwindows: "optionbtnland",
          infobaccart: "infobaccartland",


          winamount_baccart: "winamnt_baccartland",
          topsection_Baccarat: "topsection_Baccaratland", baccaratuser: this.state.user,
          // toppanneltext:"topbaccartpanneltext",
          volume_infrmcontainer: "valume_informiconscontainerland",
          chipsbaccart: "baccat_chipsland",
          incredecrebtns: "incredecrebtnsbaccartland", baccaratchipscontainer: "baccarachpcontainerport", carebbeanbetchipstoante: "chiptoplayerbaccaratport"
        })
        Baccarat_table.classList.add(this.state.Baccarattable)
        Baccarat_bgport.classList.add(this.state.bgbaccartport)
        Baccarat_table.classList.add(this.state.baccaratbetpannel)
        topbaccartpannel.classList.add(this.state.topsection_Baccarat)
        // toppannelcntrbaccart.classList.add(this.state.toppanneltext)
        volumeinformicons.classList.add(this.state.volume_infrmcontainer)
        btns_baccarat.classList.add(this.state.incredecrebtns)
        baccartchips.classList.add(this.state.baccaratchipscontainer)
        betchipsBaccarat.classList.add(this.state.chipsbaccart)
        // Baccarat_table.classList.add(this.state.Baccarattable)
        // Baccarat_table.classList.add(this.state.baccaratbetpannel)
        // topbaccartpannel.classList.add(this.state.topsection_Baccarat)
        // // toppannelcntrbaccart.classList.add(this.state.toppanneltext)
        // volumeinformicons.classList.add(this.state.volume_infrmcontainer)
        // btns_baccarat.classList.add(this.state.incredecrebtns)
        // baccartchips.classList.add(this.state.baccaratchipscontainer)
        // betchipstoantebet.classList.add(this.state.baccaratchipscontainer)
        // switch (this.state.count) {

        //   case 1:

        //     betchipsBaccarat.src = chip_10;
        //     document.getElementById("val0").classList.remove("incrementval_windowscrbn");
        //     document.getElementById("val0").textContent = this.chipVal[0].label;
        //     document.getElementById("val0").classList.add("valtext_windows_chip10bcrt", "chip_10text");

        //     // alert("...."+ betchipsRussianpoker.src)
        //     break;
        //   case 2:
        //     betchipsBaccarat.src = chip_25;
        //     break;
        //   case 3:
        //     betchipsBaccarat.src = chip_50;
        //     break;
        //   case 4:
        //     betchipsBaccarat.src = chip_100;
        //     break;
        //   case 5:
        //     betchipsBaccarat.src = chip_500;
        //     break;
        //   default:
        //     break;
        // }
        const chipMap = {
          1: { chip: chip_10, extraClass: chiptextbaccart },
          2: { chip: chip_25, extraClass: "" },
          3: { chip: chip_50, extraClass: "" },
          4: { chip: chip_100, extraClass: "" },
          5: { chip: chip_500, extraClass: "" },
          6: { chip: chip_1000, extraClass: "" }
        };

        const val0 = document.getElementById("val0");
        val0.className = chiptextbaccart;
        val0.textContent = this.chipVal[this.state.count - 1]?.label || "";

        if (chipMap[this.state.count]) {
          betchipsBaccarat.src = chipMap[this.state.count].chip;
          if (chipMap[this.state.count].extraClass) {
            val0.classList.add(...chipMap[this.state.count].extraClass.split(" "));
          }
        }
      }
      switch (this.state.count) {

        case 1:

          betchipsBaccarat.src = chip_10;
          document.getElementById("val0").classList.remove("incrementval_windowscrbn");
          document.getElementById("val0").textContent = this.chipVal[0].label;
          document.getElementById("val0").classList.add(chiptextbaccart);

          // alert("...."+ betchipsRussianpoker.src)
          break;
        case 2:
          betchipsBaccarat.src = chip_25;
          break;
        case 3:
          betchipsBaccarat.src = chip_50;
          break;
        case 4:
          betchipsBaccarat.src = chip_100;
          break;
        case 5:
          betchipsBaccarat.src = chip_500;
          break;
        default:
          break;
      }

    }





  }

  handleVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      console.log("The game is in the background or the user switched tabs.");
      // Pause the game, animations, or sound

    } else if (document.visibilityState === "visible") {

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {
        this.setState({
          heightOfLayer: 948,
          widthOfLayer: 2350,
        })
      }
      else {
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) {
          this.setState({
            heightOfLayer: 535,
            widthOfLayer: 877,

          })
        }
        else {
          this.setState({
            heightOfLayer: 526,
            widthOfLayer: 1555,


          })

        }


      }
    }

  };

  componentWillUnmount() {
    clearInterval(this.interval);
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    document.removeEventListener('keydown', this.handleKeyDownbaccarat);
    // document.removeEventListener("keydown", this.Russian_handleKeyboardEvent);
    window.removeEventListener("resize", this.handleResize);


  }
  handleKeyDownbaccarat(event) {

    console.log(event.key)
    //   if (event.key === 'Tab' || "Enter") {

    event.preventDefault();  // Disable the Tab key globally
    console.log('Tab key is disabled globally!');
    // }

  };

  checkChipValuebaccart(chipValue, chpTxt, i) {

    if (chipValue >= 1000) {
      chipValue = chipValue / 1000;
      this.checkChipValuebaccart(chipValue, chpTxt, i)
    } else {
      console.log(chpTxt);
      this.showResultChipValuebaccart(chipValue, chpTxt, i);
      return chipValue
    }
  }
  showResultChipValuebaccart(chVal, chipTxt, index) {
    console.log(chVal);
    console.log(chVal + "" + chipTxt)
    this.chipVal[index].label = chVal + "" + chipTxt;
    console.log(this.chipVal)
  }
  enableprevbetsbuttons = (betStringbaccart) => {

    this.setState({
      isBet: false, clearrebet2: true,
      betrebet: true, isclear: false, clerbtn_baccarat: true, beticonbaccart: true
    })
    let betstring = betStringbaccart

    let finalbets = betstring.split("|")
    console.log(finalbets)
    let player_betsbaccarat = finalbets[0]
    let bankerbets = finalbets[1]
    let tiebets = finalbets[2]

    this.setState({ prevstateplayer_bets: player_betsbaccarat, prevstatebanker_bets: bankerbets, prevstatetie_bets: tiebets, betpannelcover_baccart: "" })

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      this.setState({

        bettext_baccart: "Bettext_Baccarat",
        cleartext_baccart: "Cleartext_Baccarat", clerbuttontn_baccarat: "clearbtn_baccart", betbutton_baccart: "betbutton_bcrt",
      }, () => {
        console.log(this.state.beticonbaccart)
      })
    }
    else {
      if (window.innerHeight > window.innerWidth) {
        this.setState({

          bettext_baccart: "Bettext_Baccaratport",
          cleartext_baccart: "Cleartext_Baccaratport", clerbuttontn_baccarat: "clearbtn_baccartport", betbutton_baccart: "betbutton_bcrtport",
          beticonbaccart: true, clerbtn_baccarat: true
        }, () => {
          console.log(this.state.beticonbaccart)
        })
      }
      else {

        this.setState({

          bettext_baccart: "Bettext_Baccaratland",
          cleartext_baccart: "Cleartext_Baccaratland", clerbuttontn_baccarat: "clearbtn_baccartland", betbutton_baccart: "betbutton_bcrtland",
          beticonbaccart: true, clerbtn_baccarat: true
        }, () => {
          console.log(this.state.beticonbaccart)
        })

      }
    }
  }

  handleResize() {
    // alert("...................")

    console.log("calling resize");
    // document.getElementById("crbnbgim_crbn");
    this.handleOrientationChange();
  }
  handleOrientationChange = () => {

    if (this.state.isbetsonpannel) {

      this.buttonsenablebaccart();

    }
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      if (this.NavigateState) {
      } else {
        window.location.reload()
      }
    } else {
      if (this.NavigateState) {
        window.location.reload()
      } else {
      }
    }

    if (this.state.enebleprevbuttons) {
      this.enableprevbetsbuttons(this.props.gameState.response.betString);
    }
    // let Baccarat_table = document.getElementById("Baccart_Table")
    // let Baccarat_bgport = document.getElementById("Baccart_bgport")
    // let betpannel_baccart = document.getElementById("betpannel_baccarat")
    // let topbaccartpannel = document.getElementById('Baccart_topsection')
    // let toppannelcntrbaccart = document.getElementById('toppannel')
    // let volumeinformicons = document.getElementById('sound_infromicons')
    // let btns_baccarat = document.getElementById('btns_incrementdecrement')
    // let baccartchips = document.getElementById('betchipsbaccarat_Container')
    // const betchipsBaccarat = document.getElementById("betchipsbaccart");



    let Baccarat_table = document.getElementById("Baccart_Table")
    let Baccarat_bgport = document.getElementById("Baccart_bgport")
    let betpannel_baccart = document.getElementById("betpannel_baccarat")
    let topbaccartpannel = document.getElementById('Baccart_topsection')
    let toppannelcntrbaccart = document.getElementById('toppannel')
    let volumeinformicons = document.getElementById('sound_infromicons')
    let btns_baccarat = document.getElementById('btns_incrementdecrement')
    let baccartchips = document.getElementById('betchipsbaccarat_Container')
    const betchipsBaccarat = document.getElementById("betchipsbaccart");
    const betchipstoantebet = document.getElementById(`baccartbets${this.state.carebbeanidincrement}`);
    const infocontainer_baccart = document.getElementById("infocontainerbaccart");
    const minmaxbet_baccart = document.getElementById("minmaxbetbaccart");




    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      this.tableImg = baccarttable_window;

      const chipMap = {
        1: { chip: chip_10, extraClass: "valtext_windows_chip10bcrt chip_10text" },
        2: { chip: chip_25, extraClass: "" },
        3: { chip: chip_50, extraClass: "" },
        4: { chip: chip_100, extraClass: "" },
        5: { chip: chip_500, extraClass: "" },
        6: { chip: chip_1000, extraClass: "" }
      };

      const val0 = document.getElementById("val0");
      val0.className = "valtext_windowsbcrat";
      val0.textContent = this.chipVal[this.state.count - 1]?.label || "";

      if (chipMap[this.state.count]) {
        betchipsBaccarat.src = chipMap[this.state.count].chip;
        if (chipMap[this.state.count].extraClass) {
          val0.classList.add(...chipMap[this.state.count].extraClass.split(" "));
        }
      }

      // alert("windows");
      // console.log("not a mobile");
      this.setState({
        heightOfLayer: 948,
        widthOfLayer: 2350,
        // dealerDistanceFromX: 250,
        // playerDistanceFromX: 1020,    
        dealerDistanceFromX: 850,
        playerDistanceFromX: 800,
        dealerDistanceFromY: -60,
        PlayerDistanceFromY: -150,
        isMobilePortraitLndsp: false,
        scaleX: 1.8,
        scaleY: 1.8,
        activeScreen: 0,
        baccaratuser: this.state.user,
        phanddetails_baccarat: "phandbaccartwindws",
        incredecrebtns: "incredecrebtnsbaccart",
        baccartdeckcards: "windowsbaccart_deck",
        Baccarattable: "Baccarat_tablewindows",
        baccartminmax_bets: "minmaxbets_windowsbaccart",
        baccaratbetpannel: "bet_pannelbaccartwindows",
        topsection_Baccarat: "topsection_Baccarat", baccaratuser: this.state.user,
        // toppanneltext:"topbaccartpanneltext",
        volume_infrmcontainer: "valume_informiconscontainer",
        chipsbaccart: "baccat_chipswindows",
        infobaccart: "windowsinfobaccart",

        userbaccart: "username_baccartwindows",
        balncebaccart: "balnce_baccartwindows",
        totlbetbaccart: "totalbets_baccartwindows",
        winamount_baccart: "winamnt_baccartwindows",
        incredecrebtns: "incredecrebtnsbaccart", baccaratchipscontainer: "baccarachpcontainer", carebbeanbetchipstoante: "chiptoplayerbaccarat",

        // toppanneltext:"topbaccartpanneltext",
        optionbtnwindows: "",
        balance_baccarticn: "",
        bet__iconbaccart: "",
        winner_iconbaccart: "",
        usericonbaccart: "",





        // Baccarattable: "Baccarat_tablewindows",
        // baccartminmax_bets: "minmaxbets_windowsbaccart",
        // baccaratbetpannel: "bet_pannelbaccartwindows",
        // topsection_Baccarat: "topsection_Baccarat", baccaratuser: this.state.user,
        // toppanneltext:"topbaccartpanneltext",
        // volume_infrmcontainer: "valume_informiconscontainer",
        // chipsbaccart: "baccat_chipswindows",
        // infobaccart: "windowsinfobaccart",
        // baccartdeckcards: "windowsbaccart_deck",

        // userbaccart: "username_baccartwindows",
        // balncebaccart: "balnce_baccartwindows",
        // totlbetbaccart: "totalbets_baccartwindows",
        // winamount_baccart: "winamnt_baccartwindows",
        // incredecrebtns: "incredecrebtnsbaccart", baccaratchipscontainer: "baccarachpcontainer", carebbeanbetchipstoante: "chiptoplayerbaccarat"


        // Baccarat_table.classList.add(this.state.Baccarattable)
        // Baccarat_table.classList.add(this.state.baccaratbetpannel)
        // topbaccartpannel.classList.add(this.state.topsection_Baccarat)
        // // toppannelcntrbaccart.classList.add(this.state.toppanneltext)
        // volumeinformicons.classList.add(this.state.volume_infrmcontainer)
        // btns_baccarat.classList.add(this.state.incredecrebtns)
        // baccartchips.classList.add(this.state.baccaratchipscontainer)
        // betchipsBaccarat.classList.add(this.state.chipsbaccart)


      })


    }

    else {
      // let chiptextbaccart
      // chiptextbaccart=""
      if (window.innerHeight > window.innerWidth) {
        this.tableImg = baccarattable_port;
        this.setState({ chipsbaccartval: "valtextPortrait_baccart" })
        // chiptextbaccart = "valtextPortrait_baccart"



        if (this.state.lowBalaceErrorInfo != "") {

          this.setState({
            popupbet_errbalncebc: "popupbetshighbaccartport",
            textbets_highbaccart: "poptextBetshighbaccartport",
            attentionbaccart: "attention_textbaccartport",
            exitbtnbaccart: "exit_popupbcrtport"
          })


        }
        this.setState({
          heightOfLayer: 535,
          widthOfLayer: 877,
          // dealerDistanceFromX: 40,
          // playerDistanceFromX: 180,
          dealerDistanceFromX: 150,
          dealerDistanceFromY: 20,
          playerDistanceFromX: -200,
          PlayerDistanceFromY: -60,


          isMobilePortraitLndsp: true,
          scaleX: 2.8,
          scaleY: 2.8,
          activeScreen: 1,

          // Baccarattable: "Baccarat_tableportr",
          // bgbaccartport: "Baccarat_bgportgame",
          // baccaratbetpannel: "bet_pannelbaccartport",
          // topsection_Baccarat: "topsection_Baccarat", 

          payout_bodyubaccrt: "payout_bodybaccartprtrt",
          payout_mainhead: "payoutheadingbaccartprtrt",
          baccart_history: "showprevhsrytbleportraite_bcrt",
          paytablebcrt: "paytablebaccartport",
          optionsmenubutton: "optionsmenu_portraite_bcrt",
          baccartdeckcards: "baccart_deckport",
          scoreplyrbnker: "displyscoreport",
          playerscoretext: "playerscoretextport",
          bankerscoretext: "bankerscoretextport",
          baccaratuser: this.state.user,
          Baccarattable: "Baccarat_tableportr",
          baccartminmax_bets: "minmaxbets_portbaccart",
          bgbaccartport: "Baccarat_bgportgame",
          baccaratbetpannel: "bet_pannelbaccartport",
          usericonbaccart: "user_baccaticonport",
          userbaccart: "username_baccartport",
          balncebaccart: "balnce_baccartport",
          infobaccart: "info_baccartport",
          optionbtnwindows: "optionbtnport",
          balance_baccarticn: "balance_baccarticnport",
          bet__iconbaccart: "beticonbaccartport",
          winner_iconbaccart: "winnericonportbaccart",
          totlbetbaccart: "totalbets_baccartport",
          winamount_baccart: "winamnt_baccartport",
          topsection_Baccarat: "topsection_Baccaratport", baccaratuser: this.state.user,
          // toppanneltext:"topbaccartpanneltext",
          volume_infrmcontainer: "valume_informiconscontainerport",
          chipsbaccart: "baccat_chipsport",
          phanddetails_baccarat: "phandbaccartport",

          incredecrebtns: "incredecrebtnsbaccartport",
          baccaratchipscontainer: "baccarachpcontainerport",
          carebbeanbetchipstoante: "chiptoplayerbaccaratport"
          // toppanneltext:"topbaccartpanneltext",
          // volume_infrmcontainer: "valume_informiconscontainerport",
          // chipsbaccart: "baccat_chipsport",
          // incredecrebtns: "incredecrebtnsbaccartport", baccaratchipscontainer: "baccarachpcontainerport", carebbeanbetchipstoante: "chiptoplayerbaccaratport"
        })

        Baccarat_table.classList.add(this.state.Baccarattable)
        Baccarat_bgport.classList.add(this.state.bgbaccartport)
        betpannel_baccart.classList.add(this.state.baccaratbetpannel)
        topbaccartpannel.classList.add(this.state.topsection_Baccarat)
        // toppannelcntrbaccart.classList.add(this.state.toppanneltext)
        volumeinformicons.classList.add(this.state.volume_infrmcontainer)
        btns_baccarat.classList.add(this.state.incredecrebtns)
        baccartchips.classList.add(this.state.baccaratchipscontainer)
        betchipsBaccarat.classList.add(this.state.chipsbaccart)




      }
      else {




        this.tableImg = baccarattable_land;
        // chiptextbaccart=""
        // chiptextbaccart = "valtextLandscapebaccart"
        this.setState({ chipsbaccartval: "valtextLandscapebaccart" })

        if (this.state.lowBalaceErrorInfo != "") {

          this.setState({
            popupbet_errbalncebc: "popupbetshighbaccartland",
            textbets_highbaccart: "poptextBetshighbaccartland",
            attentionbaccart: "attention_textbaccartland", exitbtnbaccart: "exit_popupbcrtland"
          })


        }

        this.setState({
          // heightOfLayer: 900,
          // widthOfLayer: 1600,
          // heightOfLayer: 698,
          // widthOfLayer: 720,
          heightOfLayer: 526,
          widthOfLayer: 1555,


          dealerDistanceFromX: 850,
          dealerDistanceFromY: -20,

          playerDistanceFromX: -160,
          PlayerDistanceFromY: -100,
          isMobilePortraitLndsp: true,
          scaleX: 2.8,
          scaleY: 2.8,
          activeScreen: 1,

          // Baccarattable: "Baccarat_tableland",
          // bgbaccartport: "Baccarat_bglandgame",
          // baccaratbetpannel: "bet_pannelbaccartland",
          // topsection_Baccarat: "topsection_Baccarat", 

          baccaratuser: this.state.user,
          payout_bodyubaccrt: "payout_bodybaccartlndspe",
          payout_mainhead: "payoutheadingbaccartlndspe",

          baccart_history: "showprevhsrytblelndsbcrt",
          paytablebcrt: "paytablebaccartlndspe",
          phanddetails_baccarat: "phandbaccartland",
          volume_infrmcontainer: "valume_informiconscontainerland",
          // toppanneltext:"topbaccartpanneltext",
          // volume_infrmcontainer: "valume_informiconscontainerport",
          // chipsbaccart: "baccat_chipsland",
          // incredecrebtns: "incredecrebtnsbaccartland", baccaratchipscontainer: "baccarachpcontainerport", carebbeanbetchipstoante: "chiptoplayerbaccaratport"
          scoreplyrbnker: "displyscoreland",

          optionsmenubutton: ".optionsmenu_lndspe_bcrt",
          playerscoretext: "playerscoretextland",
          bankerscoretext: "bankerscoretextland",
          Baccarattable: "Baccarat_tableland",
          bgbaccartport: "Baccarat_bglandgame",
          baccaratbetpannel: "bet_pannelbaccartland",
          usericonbaccart: "user_baccaticonland",
          userbaccart: "username_baccartland",
          baccartminmax_bets: "minmaxbets_landbaccart",
          balncebaccart: "balnce_baccartland",
          totlbetbaccart: "totalbets_baccartland",
          balance_baccarticn: "balance_baccarticnland",
          bet__iconbaccart: "beticonbaccartland",
          winner_iconbaccart: "winnericonlandbaccart",
          optionbtnwindows: "optionbtnland",
          infobaccart: "infobaccartland",
          baccartdeckcards: "baccart_decklndspe",

          winamount_baccart: "winamnt_baccartland",
          topsection_Baccarat: "topsection_Baccaratland", baccaratuser: this.state.user,
          // toppanneltext:"topbaccartpanneltext",
          // volume_infrmcontainer: "valume_informiconscontainerport",
          chipsbaccart: "baccat_chipsland",
          incredecrebtns: "incredecrebtnsbaccartland", baccaratchipscontainer: "baccarachpcontainerport", carebbeanbetchipstoante: "chiptoplayerbaccaratport"
        })

        Baccarat_table.classList.add(this.state.Baccarattable)
        Baccarat_bgport.classList.add(this.state.bgbaccartport)
        betpannel_baccart.classList.add(this.state.baccaratbetpannel)
        topbaccartpannel.classList.add(this.state.topsection_Baccarat)
        // toppannelcntrbaccart.classList.add(this.state.toppanneltext)
        volumeinformicons.classList.add(this.state.volume_infrmcontainer)
        btns_baccarat.classList.add(this.state.incredecrebtns)
        baccartchips.classList.add(this.state.baccaratchipscontainer)
        betchipsBaccarat.classList.add(this.state.chipsbaccart)

      }

      switch (this.state.count) {

        case 1:

          betchipsBaccarat.src = chip_10;
          document.getElementById("val0").classList.remove("incrementval_windowscrbn");
          document.getElementById("val0").textContent = this.chipVal[0].label;
          document.getElementById("val0").classList.add(this.state.chipsbaccartval);

          // alert("...."+ betchipsRussianpoker.src)
          break;
        case 2:
          betchipsBaccarat.src = chip_25;
          break;
        case 3:
          betchipsBaccarat.src = chip_50;
          break;
        case 4:
          betchipsBaccarat.src = chip_100;
          break;
        case 5:
          betchipsBaccarat.src = chip_500;
          break;
        default:
          break;
      }


    }








  }


  updateMessage(erroinfo) {

    this.setState({ infoText: erroinfo })

  }
  clearallsettimeouts = () => {
    for (let i = 1; i <= this.clearTimingLeft.length; i++) {
      clearTimeout(this.clearTimingLeft[i]);
      console.log(this.clearTimingLeft[i]);
    }
  }

  // initializeChipSound = () => {
  //   let chipSound = new Howl({
  //     src: [pokerchipsnd],
  //     html5: true, // Enable HTML5 Audio for mobile compatibility
  //   });
  //   this.setState({
  //     chipSound,
  //     isPlayingChip: false
  //   })
  //   return chipSound
  // }
  // playPokerChipSound = (chipSound) => {
  //   const { isPlayingChip, mutesounds } = this.state;
  //   let currentSound = chipSound;
  //   if (!mutesounds) {

  //     if (isPlayingChip) {
  //       chipSound.stop();
  //     }
  //     if (!chipSound) {
  //       currentSound = this.initializeChipSound();
  //     }

  //     currentSound.play();
  //     this.setState({
  //       isPlayingChip: true
  //     })
  //   }

  // };
  // initializeBetSound = () => {
  //   try {
  //     const betSound = new Howl({
  //       src: [betchipsnd],
  //       html5: true, // Enable HTML5 Audio for mobile compatibility
  //     });
  //     this.setState({
  //       betSound,
  //       isPlayingBet: false,
  //     });
  //     return betSound;
  //   } catch (error) {
  //     console.error("Error initializing bet sound:", error);
  //     return null;
  //   }
  // };


  // initializePlayerWinSound = () => {

  //   let winSound = new Howl({
  //     src: [playerWin],
  //     html5: true,
  //   });

  //   return winSound


  // }
  // initializePlayerLoseSound = () => {
  //   let winSound = new Howl({
  //     src: [playerLose],
  //     html5: true,
  //   });

  //   return winSound

  // }






  // playPokerChipSound = (chipSound) => {
  //   const { isPlayingChip, mutesounds } = this.state;
  //   let currentSound = chipSound;
  //   if (!mutesounds) {

  //     if (isPlayingChip) {
  //       chipSound.stop();
  //     }
  //     if (!chipSound) {
  //       currentSound = this.initializeChipSound();
  //     }

  //     currentSound.play();
  //     this.setState({
  //       isPlayingChip: true
  //     })
  //   }

  // };














  betChipsIncrementDecremenAction = () => {
    const betchipsBaccarat = document.getElementById("betchipsbaccart");

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      const chipMap = {
        1: { chip: chip_10, extraClass: "valtext_windows_chip10bcrt chip_10text" },
        2: { chip: chip_25, extraClass: "" },
        3: { chip: chip_50, extraClass: "" },
        4: { chip: chip_100, extraClass: "" },
        5: { chip: chip_500, extraClass: "" },
        6: { chip: chip_1000, extraClass: "" }
      };

      const val0 = document.getElementById("val0");
      val0.className = "valtext_windowsbcrat";
      val0.textContent = this.chipVal[this.state.count - 1]?.label || "";

      if (chipMap[this.state.count]) {
        betchipsBaccarat.src = chipMap[this.state.count].chip;
        if (chipMap[this.state.count].extraClass) {
          val0.classList.add(...chipMap[this.state.count].extraClass.split(" "));
        }
      }



    } else {
      document.getElementById("val0").textContent = "";
      document.getElementById("val1").textContent = "";
      document.getElementById("val2").textContent = "";
      document.getElementById("val3").textContent = "";

      const isPortrait = window.innerHeight > window.innerWidth;
      let chiptextbaccart
      if (isPortrait) {
        chiptextbaccart = "valtextPortrait_baccart"

      }
      else {
        chiptextbaccart = "valtextLandscapebaccart"

      }


      console.log(this.state.count)
      // document.getElementById("val0").classList.remove("valtextPortrait1_crbn");

      switch (this.state.count) {
        case 1:
          console.log(this.storebetchips);
          betchipsBaccarat.src = chip_10;
          document.getElementById("val0").textContent = this.chipVal[0].label;
          // this.setState({ anteBetAmount: Number(this.chipVal[0].val) })
          // document.getElementById("val0").classList.add("valtextPortrait_baccart", "valtextPortrait1_crbn");
          document.getElementById("val0").classList.add(chiptextbaccart);


          break;
        case 2:
          // this.setState({ anteBetAmount: Number(this.chipVal[1].val) })
          document.getElementById("val0").textContent = this.chipVal[1].label;
          document.getElementById("val0").classList.add(chiptextbaccart);

          betchipsBaccarat.src = chip_25;
          break;
        case 3:
          // this.setState({ anteBetAmount: Number(this.chipVal[2].val) })
          document.getElementById("val0").textContent = this.chipVal[2].label;
          document.getElementById("val0").classList.add(chiptextbaccart);
          betchipsBaccarat.src = chip_50;

          break;
        case 4:
          // this.setState({ anteBetAmount: Number(this.chipVal[3].val) })
          document.getElementById("val0").textContent = this.chipVal[3].label;
          document.getElementById("val0").classList.add(chiptextbaccart);
          betchipsBaccarat.src = chip_100;

          break;
        case 5:
          // this.setState({ anteBetAmount: Number(this.chipVal[4].val) })
          document.getElementById("val0").textContent = this.chipVal[4].label;
          document.getElementById("val0").classList.add(chiptextbaccart);
          betchipsBaccarat.src = chip_500;
          break;
        case 6:
          // this.setState({ anteBetAmount: Number(this.chipVal[4].val) })
          // this.setState({ totalbet: 500 })
          document.getElementById("val0").textContent = this.chipVal[5].label;
          document.getElementById("val0").classList.add(chiptextbaccart);
          betchipsBaccarat.src = chip_1000;
          break;

        default:
          break;
      }




    }

  }

  // playPokerBetSound = (chipSound) => {

  //   const { isPlayingBet, mutesounds } = this.state;
  //   let currentSound = chipSound;

  //   if (!mutesounds) {

  //     if (isPlayingBet && chipSound && typeof chipSound.stop === "function") {
  //       chipSound.stop();
  //     }


  //     if (!chipSound || typeof chipSound.play !== "function") {
  //       currentSound = this.initializeBetSound();
  //     }


  //     if (currentSound && typeof currentSound.play === "function") {

  //       currentSound.play();
  //       this.setState({
  //         isPlayingBet: true,
  //       });
  //     } else {
  //       console.error("Invalid sound object. Unable to play sound.");
  //     }
  //   }
  // };


  IncreamentBetchips = () => {
    let addDisable = document.getElementById('betincrenetcrbn')
    let decreasrDisable = document.getElementById('betdecrementcrbn')
    if (this.state.count < 6) {
      decreasrDisable.classList.remove('baccartopacitybtn')
      this.Howlersounds.current?.playSound("betchipsnd")
      this.setState(
        (prevState) => ({
          count: prevState.count + 1,
        }),

        () => {
          console.log(this.state.count)

          if (this.state.count > 6) {
            this.setState({ betchipincrementbtn: true, betdecreamentbtn: false });

          }
          else {
            this.Howlersounds.current?.playSound("betchipsnd")
            this.setState({ betchipincrementbtn: false });

          }
          // let balance=100
          // // if(this.balnce<=this.props.minBetAmt){
          //   if(balance<=this.props.minBetAmt){
          //     // if(balance>this.props.maxBetAmt){
          //       alert("..............")

          // document.getElementById("betincrenetcrbn").classList.add("drwnodrop")
          // document.getElementById("betdecrement").classList.add("drwnodrop")

          //   this.setState({infoText: this.props.language.MinBetAmt+" "+this.props.minBetLbl+" "+this.props.language.MaxBetAmt+" "+this.props.maxBetLbl,
          //     betchipincrementbtn:true

          //   })
          //     }
          // // }
          // else{
          //   this.setState({betchipincrementbtn:false})
          //   document.getElementById("betincrenetcrbn").classList.remove("drwnodrop")
          //   document.getElementById("betdecrement").classList.remove("drwnodrop")

          // }
          this.betChipsIncrementDecremenAction()

          if (this.state.count < 6) {
            decreasrDisable.classList.remove('baccartopacitybtn')
          } else {
            addDisable.classList.add('baccartopacitybtn')
            decreasrDisable.classList.remove('baccartopacitybtn')
          }
        })



    }


    console.log("this.state.count", this.state.count, "betdecreamentbtn", this.state.betdecreamentbtn, 'betchipincrementbtn', this.state.betchipincrementbtn)
  };



  DecreamentBetchips = () => {
    console.log("this.state.count", this.state.count, "betdecreamentbtn", this.state.betdecreamentbtn, 'betchipincrementbtn', this.state.betchipincrementbtn)
    // if (this.state.count == 1) {
    //   document.getElementById("betdecrement").disabled = true;
    // }

    const betchipsBaccarat = document.getElementById("betchipscrbn");

    let addDisable = document.getElementById('betincrenetcrbn')
    let decreasrDisable = document.getElementById('betdecrementcrbn')

    if (this.state.count > 1) {
      addDisable.classList.remove('baccartopacitybtn')
      // this.betchipsnd = new Audio(betchipsnd);
      this.setState(
        (prevState) => ({
          count: prevState.count - 1,
        }),
        () => {

          console.log(this.state.count)
          if (this.state.count < 1) {
            this.setState({ betdecreamentbtn: true, betchipincrementbtn: false });
          } else {
            this.Howlersounds.current?.playSound("betchipsnd")
            this.setState({ betdecreamentbtn: false });
          }

          this.betChipsIncrementDecremenAction();

          // alert(".........."+this.state.count)
          // switch (this.state.count) {
          //   case 1:
          //     betchipsBaccarat.src = chip_10;
          //     break;
          //   case 2:
          //     betchipsBaccarat.src = chip_25;
          //     break;
          //   case 3:
          //     betchipsBaccarat.src = chip_50;
          //     break;
          //   case 4:
          //     betchipsRussianpoker.src = chip_100;
          //     break;
          //   case 5:
          //     betchipsRussianpoker.src = chip_500;
          //     break;
          //   default:
          //     break;
          // }

          if (this.state.count > 1) {
            addDisable.classList.remove('baccartopacitybtn')
          } else {
            decreasrDisable.classList.add('baccartopacitybtn')
            addDisable.classList.remove('baccartopacitybtn')
          }
        }
      );



    }



  };


















  onDrawingCards(data, drawBuyHideAndShow) {

    console.log(data);
    let cnt = data.length;
    for (let i = 0; i < cnt; i++) {
      var b1 = data[i];
      // if (b1) {
      // this.cardsshuffle = new Audio(cardsshuffle);
      // this.cardsshuffle.currentTime = 0;

      // if (this.cardsshuffle) {
      //   this.cardsshuffle.currentTime = 0;
      //   if (this.state.mutesounds) {
      //     this.cardsshuffle.pause();
      //   } else {
      //     this.cardsshuffle.play();
      //   }
      // }

      // 
      // }
      switch (i) {
        case 0:

          this.cardsRef.current.SuffleCard("cardZero", b1, cnt);
          break;
        case 1:
          this.cardsRef.current.SuffleCard("cardOne", b1, cnt);
          break;
        case 2:
          this.cardsRef.current.SuffleCard("cardTwo", b1, cnt);
          break;
        case 3:
          this.cardsRef.current.SuffleCard("cardThree", b1, cnt);
          break;
        case 4:
          this.cardsRef.current.SuffleCard("cardFour", b1, cnt);
          break;
        case 5:
          this.cardsRef.current.SuffleCard("cardFive", b1, cnt);
          break;
        default:
          break;
      }
    }

    this.clertime6 = setTimeout(() => {

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        this.showParamBetStatus()

      }

      else {
        this.showParamBetStatus()

      }
    }, 2000)
  }







  // updateplayerbalnace = () => {
  //   this.props.gamstateHandle();
  //   // this.setState({betdeductions:0,noupdateblnce:true})
  //   const body2 = {
  //     CN: "GET_PLAYER_INFO",
  //     object: {
  //       gameId: Number(this.props.gameId,),
  //       playerId: Number(this.props.playerId),

  //     },
  //     sessionId: sessionStorage.getItem('sessionId'),
  //   }
  //   this.props.network.sendof(body2);
  //   this.body2 = {};



  // }



  Undobetscaribbean() {

    if (this.state.isoptionmenu === true) {
      this.Showoptionsmenu();
    }

    this.Howlersounds.current?.playSound("clearSnd")

    this.hidepopup_betshigh();


    this.setState({ showpayouts: false })
    console.log(this.state.totalbet_baccart)
    let final_totalbetsbaccart
    if (this.state.total_betbaccart > 0) {

      let lastbeton_pannel = this.state.Bets_tracker
      let lastbettracker = lastbeton_pannel.pop();
      console.log(lastbettracker)
      let totalAnteBetAmount = 0
      let totalAnteBetAmountbanker = 0
      let totalAnteBetAmounttie = 0
      let convrAntebt = 0
      let convrbankerbet = 0


      switch (lastbettracker) {
        case "P":

          let playerbets_baccart = this.state.previousBets.player
          console.log(this.state.previousBets.player)

          let finalplayer_lastbets = playerbets_baccart.pop();


          console.log(this.state.anteBetAmount)
          console.log(finalplayer_lastbets)
          totalAnteBetAmount = this.state.anteBetAmount - finalplayer_lastbets
          console.log(totalAnteBetAmount)
          final_totalbetsbaccart = this.state.total_betbaccart - finalplayer_lastbets
          console.log(final_totalbetsbaccart)
          this.setState({ anteBetAmount: totalAnteBetAmount, total_betbaccart: final_totalbetsbaccart, betdeductbaccart: final_totalbetsbaccart })
          convrAntebt = Number(totalAnteBetAmount.toFixed(2))
          console.log(convrAntebt)
          console.log(typeof (convrAntebt))
          console.log(this.state.total_betbaccart)
          break;
        case "B":

          let bankerbets_baccart = this.state.previousBets.banker
          let finalbanker_lastbets = bankerbets_baccart.pop();
          totalAnteBetAmountbanker = this.state.betOnBanker - finalbanker_lastbets
          final_totalbetsbaccart = this.state.total_betbaccart - finalbanker_lastbets
          console.log(this.state.total_betbaccart)
          console.log(finalbanker_lastbets)
          console.log(final_totalbetsbaccart)
          this.setState({ betOnBanker: totalAnteBetAmountbanker, total_betbaccart: final_totalbetsbaccart, betdeductbaccart: final_totalbetsbaccart })
          convrbankerbet = Number(totalAnteBetAmountbanker.toFixed(2))

          console.log(this.state.total_betbaccart)
          // alert("......B")
          break;

        case "T":

          let tiebets_baccart = this.state.previousBets.tie
          let finaltie_lastbets = tiebets_baccart.pop();
          totalAnteBetAmounttie = this.state.betOnTie - finaltie_lastbets
          final_totalbetsbaccart = this.state.total_betbaccart - finaltie_lastbets

          this.setState({ betOnTie: totalAnteBetAmounttie, total_betbaccart: final_totalbetsbaccart, betdeductbaccart: final_totalbetsbaccart })
          convrbankerbet = Number(totalAnteBetAmounttie.toFixed(2))
          break;

        default:
          break

      }
      // if (
      //   navigator.userAgentData &&
      //   navigator.userAgentData.platform &&
      //   navigator.userAgentData.platform == "Windows"
      // ) {
      //   if (Number(totalAnteBetAmount) === 0 && Number(totalAnteBetAmountbanker) === 0) {
      //     alert("Both are 0: " + convrAntebt + " " + convrbankerbet);
      //     this.disablebaccartbuttons();
      // }
      if (final_totalbetsbaccart == 0) {
        this.disablebaccartbuttons();
        this.setState({ clearrebet2: false, betrebet: false, infoText: this.props.language.baccart_bet })
      }
      const chipDetails = [
        { val: this.chipVal[0].val, src: chip_10, className: "carebeanantechip_10" },
        { val: this.chipVal[1].val, src: chip_25, className: "carebeanantechip_20" },
        { val: this.chipVal[2].val, src: chip_50, className: "carebeanantechip_50" },
        { val: this.chipVal[3].val, src: chip_100, className: "carebeanantechip_100" },
        { val: this.chipVal[4].val, src: chip_500, className: "carebeanantechip_500" },
        { val: this.chipVal[5].val, src: chip_1000, className: "carebeanantechip_500" },
      ];

      const chipData = chipDetails[this.state.count - 1];

      if (chipData) {

        // betchipstoantebet.src = chipData.src;
        // if(totalAnteBetAmount == 0 && totalAnteBetAmountbanker == 0 && totalAnteBetAmounttie == 0 ){
        //   this.disablebaccartbuttons();
        // }
        // if (this.state.total_betbaccart == 0) {
        //   this.disablebaccartbuttons();
        // }
        // if(totalAnteBetAmount==0 && totalAnteBetAmountbanker==0 && totalAnteBetAmounttie==0){
        //   this.disablebaccartbuttons();
        // }
        switch (lastbettracker) {
          case "P":

            this.setState({
              storeantebetchips: [
                {
                  chip: this.ReturnChipBasedAmountUndo(Number(convrAntebt)),
                  chipvalue: this.topLable_rsp(Number(totalAnteBetAmount)),
                  chipcolor1: "valtextPortrait1"
                },

              ],
              isplayer: true

            })
            if (totalAnteBetAmount == 0) {

              gsap.set(["#chipcenterposition img", "#chipcenterposition span"], { opacity: 0 });
              this.setState({ storeantebetchips: [], isplayer: false, })

            }
            break;
          case "B":


            this.setState({
              storeBetchipsbanker: [
                {
                  chip: this.ReturnChipBasedAmountUndo(Number(convrbankerbet)),
                  // chipvalue: this.topLable_rsp(Number(totalAnteBetAmountbanker.toFixed(2))),
                  chipvalue: this.topLable_rsp(Number(totalAnteBetAmountbanker)),
                  chipcolor1: "valtextPortrait1"
                },

              ],
              isbanker: true


            })
            if (totalAnteBetAmountbanker == 0) {
              gsap.set(["#betchip_banker img", "#betchip_banker span",], { opacity: 0 });
              this.setState({ storeBetchipsbanker: [], isbanker: false, })

            }
            break;

          case "T":



            this.setState({
              storeBetchipstie: [
                {
                  chip: this.ReturnChipBasedAmountUndo(Number(convrbankerbet)),
                  chipvalue: this.topLable_rsp(Number(totalAnteBetAmounttie)),
                  chipcolor1: "valtextPortrait1"
                },

              ],
              isTie: true


            })
            if (totalAnteBetAmounttie == 0) {
              gsap.set(["#betsto_tie img", "#betsto_tie span",], { opacity: 0 });
              this.setState({ storeBetchipstie: [], isTie: false })

            }

            break;
          default:
            break

        }




        // if(totalAnteBetAmount==0 && totalAnteBetAmountbanker==0 && totalAnteBetAmounttie==0 ){

        //   this.disablebaccartbuttons();
        // }




      }
    }




  }





  Showoptionsmenu() {
    this.hidepopup_betshigh()
    this.Howlersounds.current?.playSound("selectCard")
    // this.getClickSound();
    this.setState((prevState) => {
      const isMenuOpen = !prevState.isoptionmenu;
      return {
        isoptionmenu: isMenuOpen,
        isactiveoptionsmenu: true,
        ShowLimits: isMenuOpen ? prevState.ShowLimits : false,
        ShowHistory: isMenuOpen ? prevState.ShowHistory : false,
        ShowGamerules: isMenuOpen ? prevState.ShowGamerules : false,
        showpayouts: false
      };
    }, () => {
      // this.setState((prevState) => ({ isoptionmenu:!prevState.isoptionmenu,isactiveoptionsmenu: true }), () => { 
      // this.setState({ isoptionmenu:true,isactiveoptionsmenu: true }, () => {
      // this.setState({ isoptionmenu:true,isactiveoptionsmenu: true }, () => {


      var tl = gsap.timeline();
      if (document.getElementById("optionsmenubutton")) {

        tl.to("#optionsmenubutton", {
          x: 513,
          y: 75,
          duration: 0.5,
          ease: "power2.inOut",
          zIndex: 12,
          autoAlpha: 1,
          // opacity: 1,

        });
      }
      // if (document.getElementById("optiontopmenu")) {

      //   tl.to("#optiontopmenu", {
      //     x: 316,
      //     y: 0,
      //     duration: 0.5,
      //     ease: "power2.inOut",
      //     zIndex: 12,
      //     autoAlpha: 1,
      //     // opacity: 1,

      //   });
      // }


      if (document.getElementById("limitscrbn")) {

        tl.to("#limitscrbn", {
          x: 294,
          y: -5,
          duration: 0.2,
          ease: "power2.inOut",
          zIndex: 12,
          autoAlpha: 1,
          // opacity: 1,
          stagger: 2,

        });
      }

      if (document.getElementById("help_crbn")) {
        tl.to("#help_crbn", {
          x: 294,
          y: -5,
          duration: 0.2,
          ease: "power2.inOut",
          zIndex: 12,
          opacity: 1,
          // opacity: 0.5,
          stagger: 3,

        });
      }
      if (document.getElementById("historytext_bcrt")) {
        tl.to("#historytext_bcrt", {
          x: 294,
          y: -5,
          duration: 0.2,
          ease: "power2.inOut",
          zIndex: 12,
          autoAlpha: 1,
          // opacity: 1,
          stagger: 4,

        });
      }
      // if (document.getElementById("exitmenu")) {
      //   tl.to("#exitmenu", {
      //     x: 313,
      //     y: -2,
      //     duration: 0.2,
      //     ease: "power2.inOut",
      //     zIndex: 12,
      //     autoAlpha: 1,
      //     // opacity: 1,
      //     stagger: 5,

      //   });
      // }



      tl.play()

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        if (document.getElementById("optionsmenubutton")) {
          document.getElementById("optionsmenubutton").classList.remove("optionsmenu_lndspe_bcrt");
        }

        if (document.getElementById("optionsmenubutton")) {
          document.getElementById("optionsmenubutton").classList.remove("optionsmenu_portraite_bcrt");
        }



        if (document.getElementById("optionsmenubutton")) {
          document.getElementById("optionsmenubutton").classList.add("optionsmenubcrt");
        }
        // if (document.getElementById("optiontopmenu")) {
        //   document.getElementById("optiontopmenu").classList.add("topmenu");
        // }
        if (document.getElementById("optiontext")) {
          document.getElementById("optiontext").classList.add("optionheadingbaccart");
        }
        if (document.getElementById("limitscrbn")) {
          document.getElementById("limitscrbn").classList.add("limitstext_bcrt");
        }
        if (document.getElementById("help_crbn")) {
          document.getElementById("help_crbn").classList.add("helptext_bcrt");
        }
        if (document.getElementById("historytext_bcrt")) {
          document.getElementById("historytext_bcrt").classList.add("historytext_bcrt");
        }
        if (document.getElementById("arraow")) {
          document.getElementById("arraow").classList.add("arraowtextcrbn");
        }
        // if (document.getElementById("exitmenu")) {
        //   document.getElementById("exitmenu").classList.add("exitoptionmenu");
        // }


      }
      else {
        if (window.innerHeight > window.innerWidth) {

          if (document.getElementById("optionsmenubutton")) {
            document.getElementById("optionsmenubutton").classList.remove("optionsmenu_lndspe_crbn");
          }


          if (document.getElementById("optionsmenubutton")) {
            document.getElementById("optionsmenubutton").classList.add("optionsmenu_portraite_bcrt");
          }
          // if (document.getElementById("optiontopmenu")) {
          //   document.getElementById("optiontopmenu").classList.add("topmenu");
          // }
          if (document.getElementById("optiontext")) {
            document.getElementById("optiontext").classList.add("optionheadingbcrt");
          }
          if (document.getElementById("limitscrbn")) {
            document.getElementById("limitscrbn").classList.add("limitstext_bcrt");
          }
          if (document.getElementById("help_crbn")) {
            document.getElementById("help_crbn").classList.add("helptext_bcrt");
          }
          if (document.getElementById("historytext_bcrt")) {
            document.getElementById("historytext_bcrt").classList.add("historytext_bcrt");
          }
          if (document.getElementById("arraow")) {
            document.getElementById("arraow").classList.add("arraowtextcrbn");
          }
          // if (document.getElementById("exitmenu")) {
          //   document.getElementById("exitmenu").classList.add("exitoptionmenu");
          // }


        }
        else {


          if (document.getElementById("optionsmenubutton")) {
            document.getElementById("optionsmenubutton").classList.remove("optionsmenu_portraite_crbn");
          }

          if (document.getElementById("optionsmenubutton")) {
            document.getElementById("optionsmenubutton").classList.add("optionsmenu_lndspe_bcrt");
          }
          // if (document.getElementById("optiontopmenu")) {
          //   document.getElementById("optiontopmenu").classList.add("topmenu");
          // }
          if (document.getElementById("optiontext")) {
            document.getElementById("optiontext").classList.add("optionheadingcrbn");
          }
          if (document.getElementById("limitscrbn")) {
            document.getElementById("limitscrbn").classList.add("limitstext_bcrt");
          }
          if (document.getElementById("help_crbn")) {
            document.getElementById("help_crbn").classList.add("helptext_bcrt");
          }
          if (document.getElementById("historytext_bcrt")) {
            document.getElementById("historytext_bcrt").classList.add("historytext_bcrt");
          }
          if (document.getElementById("arraow")) {
            document.getElementById("arraow").classList.add("arraowtextcrbn");
          }
          // if (document.getElementById("exitmenu")) {
          //   document.getElementById("exitmenu").classList.add("exitoptionmenu");
          // }


        }

      }
    });





  }


  ShowLimits() {
    this.setState({ ShowLimits: !this.state.ShowLimits, ShowGamerules: false, ShowHistory: this.state.ShowHistory ? false : this.state.ShowHistory }, () => {

      // exitLimits
      const exitLimitsElement = document.getElementById("exitLimits");
      // exitLimitsElement.className = "";
      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        document.getElementById("limitscrbnpopup")?.classList.remove("LimitsPopup_landspebcrt")
        document.getElementById("limitscrbnpopup")?.classList.remove("LimitsPopup_portraitebcrt")
        document.getElementById("limitscrbnpopup")?.classList.add("LimitsPopupbcrt");


        // exitLimitsElement.classList.add("exihstrybuttonportraite");
      }
      else {
        if (window.innerHeight > window.innerWidth) {
          document.getElementById("limitscrbnpopup")?.classList.remove("LimitsPopupbcrt")
          document.getElementById("limitscrbnpopup")?.classList.remove("LimitsPopup_landspebcrt")
          document.getElementById("limitscrbnpopup")?.classList.add("LimitsPopup_portraitebcrt")
          // exitLimitsElement.classList.add("exihstrybuttonportraite");

        }
        else {

          document.getElementById("limitscrbnpopup")?.classList.remove("LimitsPopupbcrt")
          document.getElementById("limitscrbnpopup")?.classList.remove("LimitsPopup_portraitebcrt")
          document.getElementById("limitscrbnpopup")?.classList.add("LimitsPopup_landspebcrt")
          // exitLimitsElement.classList.add("exihstrybuttonportraite");

        }
      }

    })

  }




  Exitoptionmenu() {
    this.setState({ isoptionmenu: false });
    var tl = gsap.timeline();
    tl.to("#optionsmenubutton", {
      x: 458,
      y: 75,
      duration: 0.5,
      ease: "power2.inOut",
      zIndex: 12,
      opacity: 1
    });
    tl.play();

  }


  topLable_rsp(value) {


    const labelValue = Math.abs(Number(value));
    return labelValue >= 1.0e+9

      ? Number((labelValue / 1.0e+9).toFixed(2)) + "B"
      // Six Zeroes for Millions 
      : labelValue >= 1.0e+6

        ? Number((labelValue / 1.0e+6).toFixed(2)) + "M"
        // Three Zeroes for Thousands
        : labelValue >= 1.0e+3

          ? Number((labelValue / 1.0e+3).toFixed(2)) + "K"

          : Number(labelValue.toFixed(2));
  }
  // topLable_rsp(labelValue) {
  //   console.log(labelValue)
  //   // Nine Zeroes for Billions
  //   return Math.abs(Number(labelValue)) >= 1.0e+9

  //     ? Math.abs(Number(labelValue)) / 1.0e+9 + "B"
  //     // Six Zeroes for Millions 
  //     : Math.abs(Number(labelValue)) >= 1.0e+6

  //       ? Math.abs(Number(labelValue)) / 1.0e+6 + "M"
  //       // Three Zeroes for Thousands
  //       : Math.abs(Number(labelValue)) >= 1.0e+3

  //         ? Math.abs(Number(labelValue)) / 1.0e+3 + "K"

  //         : Math.abs(Number(labelValue));
  // }
  // disabledrwbutton(){

  //    this.setState({drawbuttonhandle:false})
  //     document.getElementById("drawtext").classList.remove("drawtextopacity");
  // }


















  muteunmutesounds() {
    // this.getClickSound();
    this.Howlersounds.current?.playSound("selectCard")
    // this.selectCard.currentTime = 0;
    // if (this.state.mutesounds) {
    //   this.selectCard.play();
    // } else {
    //   this.selectCard.pause();
    // }

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      document.getElementById('volume_baccarat').classList.add("addpointer")
    }

    if (!this.state.mutesounds) {
      this.setState({ mutesounds: true })
      document.getElementById('volume_baccarat').src = mutesnds;

    }
    else {

      this.setState({ mutesounds: false })
      document.getElementById('volume_baccarat').src = volumeimg;

    }
  }



  hidepopup_betshigh = () => {

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

      const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_errbalnce");
      if (document.getElementById("popupbet_errbalnce")) {
        gsap.to(popupbetGreaterthanBalnceElement, {
          scale: 0,
          duration: 0.25,
          rotate: 0,
          opacity: 0,
          ease: "power2.out",
          onComplete: () => {
            // popupbetGreaterthanBalnceElement.className = "";
            // popupbetGreaterthanBalnceElement.classList.add("popupbetshighMobilecrbn");
          }

        }
        );

      }
    } else {
      const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_errbalnce");
      if (document.getElementById("popupbet_errbalnce")) {
        gsap.to(popupbetGreaterthanBalnceElement, {
          scale: 0,
          duration: 0.25,
          rotate: 0,
          opacity: 0,
          ease: "power2.out",
          onComplete: () => {
            // popupbetGreaterthanBalnceElement.className = "";
            // popupbetGreaterthanBalnceElement.classList.add("popupbetshighMobilecrbn");
          }

        }
        );

      }


    }






  }

  updatePlayerInfo() {
    this.setState({ betdeductbaccart: 0 })


    // alert("noe bet shold be deleted successfully")
    // this.setState({
    //   isbanker: false, isplayer: false,
    //   isTie: false, clerbtn_baccarat: true,
    //   beticonbaccart: true,
    //   isclear: false,
    //   isBet: false,

    //   glowpopbaccart:"",
    //   winamountbaccart:"",
    //   // bettext_baccart: "Bettext_Baccarat",
    //   // cleartext_baccart: "Cleartext_Baccarat",
    //   //  scoreplyrbnker: "displyscorewindows"

    // })
  }


  //  const rankinginfoElement = document.getElementById("rankinginfo_crbn");
  //  if (rankinginfoElement) {
  //   if (this.state.isMobilePortraitLndsp) {
  //      rankinginfoElement.style.left = "34%";
  //    }
  //  }

  // }


  ReturnChipBasedAmount = (amt) => {
    const amount = Number(amt)
    let chipImage = chip_10;
    if (Number(this.chipVal[0].val) <= amount && Number(this.chipVal[1].val) > amount) {
      chipImage = chip_10
    } else if (Number(this.chipVal[1].val) <= amount && Number(this.chipVal[2].val) > amount) {
      chipImage = chip_25
    }
    else if (Number(this.chipVal[2].val) <= amount && Number(this.chipVal[3].val) > amount) {
      chipImage = chip_50
    }
    else if (Number(this.chipVal[3].val) <= amount && Number(this.chipVal[4].val) > amount) {
      chipImage = chip_100

    } else if (Number(this.chipVal[4].val) <= amount && Number(this.chipVal[5].val) > amount) {
      chipImage = chip_500

    } else {
      chipImage = chip_1000
    }
    return chipImage
  }


  ReturnChipBasedAmountUndo = (amt) => {
    console.log(amt)

    const amount = Number(amt)
    let chipImage = "";
    if (amount === 0 || isNaN(amount)) {
      return "";
    }

    if (Number(this.chipVal[0].val) <= amount && Number(this.chipVal[1].val) > amount) {
      chipImage = chip_10


    } else if (Number(this.chipVal[1].val) <= amount && Number(this.chipVal[2].val) > amount) {
      chipImage = chip_25

    }
    else if (Number(this.chipVal[2].val) <= amount && Number(this.chipVal[3].val) > amount) {
      chipImage = chip_50
    }
    else if (Number(this.chipVal[3].val) <= amount && Number(this.chipVal[4].val) > amount) {
      chipImage = chip_100

    } else if (Number(this.chipVal[4].val) <= amount && Number(this.chipVal[5].val) > amount) {
      chipImage = chip_500

    }

    else {
      chipImage = chip_1000

    }
    return chipImage
  }

  closeMenuOption = () => {
    this.setState({
      isoptionmenu: false,
      ShowLimits: false,
      ShowHistory: false,
      ShowGamerules: false,
    })
  }
  hidepayoutbaccart = () => {
    this.setState({ showpayouts: false })

    if (this.state.isoptionmenu === true) {
      this.Showoptionsmenu();
    }
  }
  Showpayouttable = () => {
    this.hidepopup_betshigh()
    if (this.state.isoptionmenu === true) {
      this.Showoptionsmenu();
    }
    this.setState({ showpayouts: !this.state.showpayouts }, () => {
      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {



        if (document.getElementById("Payout_crbn")) {
          document.getElementById("Payout_crbn").classList.add("payout_crbn")

        }

        if (document.getElementById("PAYOUTTABLE")) {

          document.getElementById("PAYOUTTABLE").classList.add("paytablebaccart")

        }
        if (document.getElementById("payout_bodybaccart")) {
          document.getElementById("payout_bodybaccart").classList.add("payout_bodybaccart")

        }

        if (document.getElementById("heading_payout")) {
          document.getElementById("heading_payout").classList.add("payoutheadingbaccart")

        }



      }
      else {

        if (window.innerHeight > window.innerWidth) {

          if (document.getElementById("Payout_crbn")) {
            document.getElementById("Payout_crbn").classList.remove("payoutLndspebcrt")

          }

          if (document.getElementById("PAYOUTTABLE")) {
            document.getElementById("PAYOUTTABLE").classList.remove("paytablebaccartlndspe")

          }
          if (document.getElementById("payout_bodybaccart")) {
            document.getElementById("payout_bodybaccart").classList.remove("payout_bodybaccartlndspe")

          }

          if (document.getElementById("heading_payout")) {
            document.getElementById("heading_payout").classList.remove("payoutheadingbaccartlndspe")

          }

          if (document.getElementById("Payout_crbn")) {
            document.getElementById("Payout_crbn").classList.add("payout_bcrtprtrt")

          }

          if (document.getElementById("PAYOUTTABLE")) {
            document.getElementById("PAYOUTTABLE").classList.add("paytablebaccartport")

          }
          if (document.getElementById("payout_bodybaccart")) {
            document.getElementById("payout_bodybaccart").classList.add("payout_bodybaccartprtrt")

          }

          if (document.getElementById("heading_payout")) {
            document.getElementById("heading_payout").classList.add("payoutheadingbaccartprtrt")

          }



        }
        else {
          if (document.getElementById("Payout_crbn")) {
            document.getElementById("Payout_crbn").classList.remove("payout_bcrtprtrt")

          }

          if (document.getElementById("PAYOUTTABLE")) {
            document.getElementById("PAYOUTTABLE").classList.remove("paytablebaccartport")

          }
          if (document.getElementById("payout_bodybaccart")) {
            document.getElementById("payout_bodybaccart").classList.remove("payout_bodybaccartprtrt")

          }

          if (document.getElementById("heading_payout")) {
            document.getElementById("heading_payout").classList.remove("payoutheadingbaccartprtrt")

          }




          if (document.getElementById("Payout_crbn")) {
            document.getElementById("Payout_crbn").classList.add("payoutLndspebcrt")

          }

          if (document.getElementById("PAYOUTTABLE")) {
            document.getElementById("PAYOUTTABLE").classList.add("paytablebaccartlndspe")

          }
          if (document.getElementById("payout_bodybaccart")) {
            document.getElementById("payout_bodybaccart").classList.add("payout_bodybaccartlndspe")

          }

          if (document.getElementById("heading_payout")) {
            document.getElementById("heading_payout").classList.add("payoutheadingbaccartlndspe")

          }


        }

      }

    })
  }
  ShowHistory() {



    this.setState({ ShowHistory: !this.state.ShowHistory, ShowGamerules: false, ShowLimits: this.state.ShowLimits ? false : this.state.ShowLimits, ishistorytable: true }, () => {



      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {
        if (document.getElementById("histry_russian_bacacrt")) {
          document.getElementById("histry_russian_bacacrt")?.classList.remove("histry_portraitebcrt")

        }
        if (document.getElementById("exithistory")) {
          document.getElementById("exithistory")?.classList.remove("exihstrybuttonportraitecrbn")

        }
        if (document.getElementById("prevhistory_crbn")) {
          document.getElementById("prevhistory_crbn")?.classList.remove("showprevhsrytbleportraite_bcrt")

        }
        if (document.getElementById("histry_body_bcrt")) {
          document.getElementById("histry_body_bcrt")?.classList.remove("histry_bodyportraite_crbn")
        }
        if (document.getElementById("histry_russian_bacacrt")) {
          document.getElementById("histry_russian_bacacrt")?.classList.remove("heading_hstiryportraite_bcrt")

        }
        if (document.getElementById("histry_russian_bacacrt")) {
          document.getElementById("histry_russian_bacacrt")?.classList.remove("histry_russianlndspecrbn")

        }
        if (document.getElementById("exithistory")) {
          document.getElementById("exithistory")?.classList.remove("exihstrybuttonlndspecrbn")

        }
        if (document.getElementById("prevhistory_crbn")) {
          document.getElementById("prevhistory_crbn")?.classList.remove("showprevhsrytblelndsbcrt")

        }
        if (document.getElementById("histry_body_bcrt")) {
          document.getElementById("histry_body_bcrt")?.classList.remove("histry_bodylndspecrbn")

        }
        if (document.getElementById("histry_russian_bacacrt")) {
          document.getElementById("histry_russian_bacacrt")?.classList.remove("heading_hstirylndspebrt")

        }


        if (document.getElementById("histry_russian_bacacrt")) {
          document.getElementById("histry_russian_bacacrt").classList.add("histry_russian_bacacrt")

        }
        if (document.getElementById("exithistory")) {
          document.getElementById("exithistory").classList.add("exihstrybuttoncrbn")

        }
        if (document.getElementById("prevhistory_crbn")) {
          document.getElementById("prevhistory_crbn").classList.add("showprevhsrytblebaccart")

        }
        if (document.getElementById("histry_body_bcrt")) {
          document.getElementById("histry_body_bcrt").classList.add("histry_bodybcrt")

        }
        if (document.getElementById("histry_russian_bacacrt")) {
          document.getElementById("histry_russian_bacacrt").classList.add("histry_russian_bacacrt")

        }


      }
      else {

        if (window.innerHeight > window.innerWidth) {

          if (document.getElementById("histry_russian_bacacrt")) {
            document.getElementById("histry_russian_bacacrt")?.classList.remove("histry_russianlndspecrbn")

          }
          if (document.getElementById("exithistory")) {
            document.getElementById("exithistory")?.classList.remove("exihstrybuttonlndspecrbn")

          }
          if (document.getElementById("prevhistory_crbn")) {
            document.getElementById("prevhistory_crbn")?.classList.remove("showprevhsrytblelndsbcrt")

          }
          if (document.getElementById("histry_body_bcrt")) {
            document.getElementById("histry_body_bcrt")?.classList.remove("histry_bodylndspecrbn")

          }
          if (document.getElementById("histry_russian_bacacrt")) {
            document.getElementById("histry_russian_bacacrt")?.classList.remove("heading_hstirylndspebrt")

          }
          if (document.getElementById("histry_russian_bacacrt")) {
            document.getElementById("histry_russian_bacacrt")?.classList.remove("histry_russian_bacacrt")

          }
          if (document.getElementById("exithistory")) {
            document.getElementById("exithistory")?.classList.remove("exihstrybuttoncrbn")

          }
          if (document.getElementById("prevhistory_crbn")) {
            document.getElementById("prevhistory_crbn")?.classList.remove("showprevhsrytblebaccart")

          }
          if (document.getElementById("histry_body_bcrt")) {
            document.getElementById("histry_body_bcrt")?.classList.remove("histry_bodybcrt")

          }
          if (document.getElementById("histry_russian_bacacrt")) {
            document.getElementById("histry_russian_bacacrt").classList.add("histry_russian_bacacrt")

          }

          if (document.getElementById("histry_russian_bacacrt")) {
            document.getElementById("histry_russian_bacacrt").classList.add("histry_portraitebcrt")

          }
          if (document.getElementById("exithistory")) {
            document.getElementById("exithistory").classList.add("exihstrybuttonportraitecrbn")

          }
          if (document.getElementById("prevhistory_crbn")) {
            document.getElementById("prevhistory_crbn").classList.add("showprevhsrytbleportraite_bcrt")

          }
          if (document.getElementById("histry_body_bcrt")) {
            document.getElementById("histry_body_bcrt").classList.add("histry_bodyportraite_crbn")

            if (document.getElementById("histry_russian_bacacrt")) {
              document.getElementById("histry_russian_bacacrt").classList.add("heading_hstiryportraite_bcrt")

            }

          }


        }
        else {


          if (document.getElementById("histry_russian_bacacrt")) {
            document.getElementById("histry_russian_bacacrt")?.classList.remove("histry_russian_bacacrt")

          }
          if (document.getElementById("exithistory")) {
            document.getElementById("exithistory")?.classList.remove("exihstrybuttoncrbn")

          }
          if (document.getElementById("prevhistory_crbn")) {
            document.getElementById("prevhistory_crbn")?.classList.remove("showprevhsrytblebaccart")

          }
          if (document.getElementById("histry_body_bcrt")) {
            document.getElementById("histry_body_bcrt")?.classList.remove("histry_bodybcrt")

          }
          if (document.getElementById("histry_russian_bacacrt")) {
            document.getElementById("histry_russian_bacacrt")?.classList.remove("histry_russian_bacacrt")

          }

          if (document.getElementById("histry_russian_bacacrt")) {
            document.getElementById("histry_russian_bacacrt")?.classList.remove("histry_portraitebcrt")

          }
          if (document.getElementById("exithistory")) {
            document.getElementById("exithistory")?.classList.remove("exihstrybuttonportraitecrbn")

          }
          if (document.getElementById("prevhistory_crbn")) {
            document.getElementById("prevhistory_crbn")?.classList.remove("showprevhsrytbleportraite_bcrt")

          }
          if (document.getElementById("histry_body_bcrt")) {
            document.getElementById("histry_body_bcrt")?.classList.remove("histry_bodyportraite_crbn")
          }
          if (document.getElementById("histry_russian_bacacrt")) {
            document.getElementById("histry_russian_bacacrt").classList.remove("heading_hstiryportraite_bcrt")

          }


          if (document.getElementById("histry_russian_bacacrt")) {
            document.getElementById("histry_russian_bacacrt").classList.add("histry_russianlndspecrbn")

          }
          if (document.getElementById("exithistory")) {
            document.getElementById("exithistory").classList.add("exihstrybuttonlndspecrbn")

          }
          if (document.getElementById("prevhistory_crbn")) {
            document.getElementById("prevhistory_crbn").classList.add("showprevhsrytblelndsbcrt")

          }
          if (document.getElementById("histry_body_bcrt")) {
            document.getElementById("histry_body_bcrt").classList.add("histry_bodylndspecrbn")

          }
          if (document.getElementById("histry_russian_bacacrt")) {
            document.getElementById("heading_hstiry_baccart").classList.add("heading_hstirylndspebrt")

          }




        }

      }

    })


  }
  buttonsenablebaccart = () => {

    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      this.setState({
        undotex_baccarat: "Undotext_Baccarat",
        bettext_baccart: "Bettext_Baccarat",
        cleartext_baccart: "Cleartext_Baccarat", clerbuttontn_baccarat: "clearbtn_baccart", betbutton_baccart: "betbutton_bcrt", undotextcss_baccart: "undotextcss_baccart",
        beticonbaccart: true, undobtn_baccart: true, clerbtn_baccarat: true
      }, () => {
        console.log(this.state.beticonbaccart)
      })
    }
    else {
      if (window.innerHeight > window.innerWidth) {
        this.setState({
          undotex_baccarat: "Undotext_Baccaratport",
          bettext_baccart: "Bettext_Baccaratport",
          cleartext_baccart: "Cleartext_Baccaratport", clerbuttontn_baccarat: "clearbtn_baccartport", betbutton_baccart: "betbutton_bcrtport", undotextcss_baccart: "undotextcss_baccartport",
          beticonbaccart: true, undobtn_baccart: true, clerbtn_baccarat: true
        }, () => {
          console.log(this.state.beticonbaccart)
        })
      }
      else {

        this.setState({
          undotex_baccarat: "Undotext_Baccaratland",
          bettext_baccart: "Bettext_Baccaratland",
          cleartext_baccart: "Cleartext_Baccaratland", clerbuttontn_baccarat: "clearbtn_baccartland", betbutton_baccart: "betbutton_bcrtland", undotextcss_baccart: "undotextcss_baccartland",
          beticonbaccart: true, undobtn_baccart: true, clerbtn_baccarat: true
        }, () => {
          console.log(this.state.beticonbaccart)
        })

      }
    }

  }


  Gamerules = () => {
    this.setState({ ShowGamerules: !this.state.ShowGamerules, ShowHistory: false, ShowLimits: false }, () => {
      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        // this.setState({ShowGamerules:true},()=>{


        document.getElementById("ShowGamerulescrbn")?.classList.remove("Gamerulescontainerportbaccart")
        document.getElementById("gameruleMainHeadingbaccarat")?.classList.remove("gameruleMainHeadingbaccaratport")
        document.getElementById("unorderedlistitemsbaccart")?.classList.remove("unorderedlistitemsbaccartport")
        document.getElementById("ShowGamerulescrbn")?.classList.remove("Gamerulescontainerlndbaccart")
        document.getElementById("gameruleMainHeadingbaccarat")?.classList.remove("gameruleMainHeadingbaccaratlnd")
        document.getElementById("unorderedlistitemsbaccart")?.classList.remove("unorderedlistitemsbaccartlnd")

        document.getElementById("ShowGamerulescrbn")?.classList.add("Gamerulescontainerbaccart")
        document.getElementById("gameruleMainHeadingbaccarat")?.classList.add("gameruleMainHeadingbaccarat")
        document.getElementById("unorderedlistitemsbaccart")?.classList.add("unorderedlistitemsbaccart")

        // })

      }
      else {
        if (window.innerHeight > window.innerWidth) {


          document.getElementById("ShowGamerulescrbn")?.classList.remove("Gamerulescontainerbaccart")
          document.getElementById("gameruleMainHeadingbaccarat")?.classList.remove("gameruleMainHeadingbaccarat")
          document.getElementById("unorderedlistitemsbaccart")?.classList.remove("unorderedlistitemsbaccart")
          document.getElementById("ShowGamerulescrbn")?.classList.remove("Gamerulescontainerlndbaccart")
          document.getElementById("gameruleMainHeadingbaccarat")?.classList.remove("gameruleMainHeadingbaccaratlnd")
          document.getElementById("unorderedlistitemsbaccart")?.classList.remove("unorderedlistitemsbaccartlnd")

          document.getElementById("ShowGamerulescrbn")?.classList.add("Gamerulescontainerportbaccart")
          document.getElementById("gameruleMainHeadingbaccarat")?.classList.add("gameruleMainHeadingbaccaratport")
          document.getElementById("unorderedlistitemsbaccart")?.classList.add("unorderedlistitemsbaccartport")



        }
        else {

          document.getElementById("ShowGamerulescrbn")?.classList.remove("Gamerulescontainerbaccart")
          document.getElementById("gameruleMainHeadingbaccarat")?.classList.remove("gameruleMainHeadingbaccarat")
          document.getElementById("unorderedlistitemsbaccart")?.classList.remove("unorderedlistitemsbaccart")
          document.getElementById("ShowGamerulescrbn")?.classList.remove("Gamerulescontainerportbaccart")
          document.getElementById("gameruleMainHeadingbaccarat")?.classList.remove("gameruleMainHeadingbaccaratport")
          document.getElementById("unorderedlistitemsbaccart")?.classList.remove("unorderedlistitemsbaccartport")
          document.getElementById("ShowGamerulescrbn")?.classList.add("Gamerulescontainerlndbaccart")
          document.getElementById("gameruleMainHeadingbaccarat")?.classList.add("gameruleMainHeadingbaccaratlnd")
          document.getElementById("unorderedlistitemsbaccart")?.classList.add("unorderedlistitemsbaccartlnd")



        }
      }
    })
  }

  BetplaceonPlayer = (textrebet) => {
    this.Howlersounds.current?.playSound("pokerchipsnd")
    const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_errbalnce");
    const textbetsHighElement = document.getElementById("textbets_highbaccart");
    const attentionElement = document.getElementById("attentionbaccart");

    let totalBetAmountForLimitsCheck = 0;
    let totalAnteBetAmount = 0;
    let totalbetonplayer = this.state.anteBetAmount

    let inner_minplayerbets = this.innerLimits[0][0]
    let inner_maxplayerbets = this.innerLimits[0][1]


    this.newBet = 0;

    const chipDetails = [
      { val: this.chipVal[0].val, src: chip_10, className: "carebeanantechip_10", textclass: "antebet_baccart10" },
      { val: this.chipVal[1].val, src: chip_25, className: "carebeanantechip_20", textclass: "antebet_caribean20" },
      { val: this.chipVal[2].val, src: chip_50, className: "carebeanantechip_50", textclass: "antebet_caribean50" },
      { val: this.chipVal[3].val, src: chip_100, className: "carebeanantechip_100", textclass: "antebet_baccart100" },
      { val: this.chipVal[4].val, src: chip_500, className: "carebeanantechip_500", textclass: "antebet_caribean500" },
      { val: this.chipVal[5].val, src: chip_1000, className: "carebeanantechip_500", textclass: "antebet_caribean500" },
    ];
    let storebaccartgamebets = 0
    const chipData = chipDetails[this.state.count - 1];
    const maxBet = Number(this.props.maxBetAmt);

    if (textrebet === "Rebet" || textrebet === "Rebetx2") {
      const previousBet = Number(this.state.prevstateplayer_bets);
      const newRebet = textrebet === "Rebet" ? previousBet : previousBet * 2;
      if (textrebet === "Rebet") {
        for (let k = 1; k <= this.chipVal.length; k++) {
          if (this.state.count === k) {
            console.log(this.state.anteBetAmount)
            console.log(Number(this.chipVal[k - 1].val))
            totalBetAmountForLimitsCheck = previousBet;

            totalAnteBetAmount = Number(previousBet)


          }

        }
        storebaccartgamebets = previousBet
        this.setState({ anteBetAmount: storebaccartgamebets })
      }
      else {
        for (let k = 1; k <= this.chipVal.length; k++) {
          if (this.state.count === k) {
            console.log(this.state.anteBetAmount)
            console.log(Number(this.chipVal[k - 1].val))
            totalBetAmountForLimitsCheck = previousBet * 2;

            totalAnteBetAmount = Number(previousBet) * 2;

          }
        }

        storebaccartgamebets = previousBet * 2;
        if (storebaccartgamebets > inner_minplayerbets && storebaccartgamebets <= inner_maxplayerbets) {
          this.setState({ anteBetAmount: storebaccartgamebets })

        }
        else {
          this.setState({ anteBetAmount: 0 })

        }

      }

    } else {

      for (let k = 1; k <= this.chipVal.length; k++) {
        if (this.state.count === k) {
          console.log(this.state.anteBetAmount)
          console.log(Number(this.chipVal[k - 1].val))
          totalBetAmountForLimitsCheck = this.state.anteBetAmount + Number(this.chipVal[k - 1].val);
          totalAnteBetAmount = Number(this.state.anteBetAmount) + Number(this.chipVal[k - 1].val)
        }

      }
      storebaccartgamebets = this.state.total_betbaccart + Number(chipData.val)
    }


    //  this.setState({totalbets_baccart:this.newBet})
    this.hidepayoutbaccart();


    console.log(totalAnteBetAmount)
    console.log(this.props.balance)
    console.log(this.state.total_betbaccart)
    if (Number(storebaccartgamebets) <= Number(this.props.balance)) {
      if (Number(totalAnteBetAmount) <= Number(this.props.balance)) {
        if (Number(totalAnteBetAmount) >= Number(inner_minplayerbets) && Number(totalAnteBetAmount) <= Number(inner_maxplayerbets)) {



          if (Number(totalAnteBetAmount) >= Number(this.props.minBetAmt) && Number(totalAnteBetAmount) <= Number(this.props.maxBetAmt) && storebaccartgamebets <= this.props.maxBetAmt) {
            console.log(textrebet)

            let x
            let y
            this.hidepopup_betshigh();

            if (
              (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
              (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
            ) {


              x = -1013
              y = -119
              // setTimeout(() => {
              // this.setState({ isplayer: true }, () => {

              // });
              // }, 350)

              // this.BetchipanimPlayerBankerTie("baccartbets", "baccaratchip_windows", x, y);
              // setTimeout(() => {
              this.setState({ isplayer: true })

              // }, 100)

              this.BetchipanimPlayerBankerTie("baccartbets", "baccaratchip_windows", x, y);




            }
            else {
              const isPortrait = window.innerHeight > window.innerWidth;
              if (isPortrait) {

                // x = -25
                // y = -536
                x = -16
                y = -545
                setTimeout(() => {
                  this.setState({ isplayer: true })

                }, 100)
                this.BetchipanimPlayerBankerTie("baccartbets", "baccaratchip_port", x, y);

              }
              else {
                // alert("land")
                x = -1133
                y = 445
                setTimeout(() => {
                  this.setState({ isplayer: true })

                }, 100)
                this.BetchipanimPlayerBankerTie("baccartbets", "baccaratchip_land", x, y);


              }

            }
            gsap.set(["#chipcenterposition img", "#chipcenterposition span"], { opacity: 1 });

            this.buttonsenablebaccart()
            // let totalBetAmountForLimitsCheck = 0;
            // let totalAnteBetAmount = 0;
            // let totalbetonplayer = this.state.anteBetAmount



            if (textrebet === "Rebet" || textrebet === "Rebetx2") {
              let total_previousbets
              if (this.state.prevstateplayer_bets > 0 || this.state.prevstatebanker_bets > 0 || this.state.prevstatetie_bets > 0) {
                total_previousbets = Number(this.state.prevstateplayer_bets) + Number(this.state.prevstatebanker_bets) + Number(this.state.prevstatetie_bets)
                console.log(Number(this.state.prevstateplayer_bets))
                console.log(Number(this.state.prevstatebanker_bets))
                console.log(Number(this.state.prevstatetie_bets))

              }




              if (textrebet == "Rebet") {

                console.log(this.state.prevstateplayer_bets)
                totalBetAmountForLimitsCheck = this.state.prevstateplayer_bets

                totalAnteBetAmount = this.state.prevstateplayer_bets
                // this.setState({total_betbaccart:totalAnteBetAmount})
                this.setState({ total_betbaccart: total_previousbets, betdeductbaccart: total_previousbets })

              }
              else {


                let doublebbacrtbets = this.state.prevstateplayer_bets * 2

                totalBetAmountForLimitsCheck = doublebbacrtbets

                totalAnteBetAmount = this.state.prevstateplayer_bets * 2
                // this.setState({total_betbaccart:totalAnteBetAmount})

                this.setState({ total_betbaccart: total_previousbets * 2, betdeductbaccart: total_previousbets * 2 })
              }
            }
            else {

              this.setState((prevState) => ({
                total_betbaccart: prevState.total_betbaccart + Number(chipData.val),
                betdeductbaccart: prevState.betdeductbaccart + Number(chipData.val),
              }));

            }


            this.setState((prevState) => ({

              isbetsonpannel: true,

              betsting_player: totalAnteBetAmount,
              isbaccartbets: true,
              isclear: true,
              isBet: true,
              clearrebet2: true,
              betrebet: true,
              // prevstateplayer_bets: this.state.anteBetAmount,

            }));




            if (chipData) {

              document.getElementById("baccartbets").src = chipData.src;




              this.state.Bets_tracker.push("P")
              if (textrebet === "Rebet") {
                this.state.previousBets.player.push(Number(this.state.prevstateplayer_bets))
                // this.setState({ anteBetAmount: this.state.prevstateplayer_bets })
              }
              else if (textrebet === "Rebetx2") {
                let prevstateplayerbets = Number(this.state.prevstateplayer_bets) * 2
                this.state.previousBets.player.push(prevstateplayerbets)
                // this.setState({ anteBetAmount: prevstateplayerbets })

              }
              else {
                this.state.previousBets.player.push(Number(chipData.val))

                this.setState((prevState) => ({
                  anteBetAmount: prevState.anteBetAmount + Number(chipData.val),

                }));
              }

            }



            this.setState({
              storeantebetchips: [
                {
                  chip: this.ReturnChipBasedAmount(Number(totalAnteBetAmount)),
                  // chipvalue: this.topLable_rsp(Number(totalBetAmountForLimitsCheck.toFixed(2))),
                  chipvalue: this.topLable_rsp(Number(totalBetAmountForLimitsCheck)),

                  chipcolor1: "valtextPortrait1"
                },

              ],

            })



            console.log(this.state.previousBets.player)
          }
          else {

            this.setState({ infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl })

          }
        }
        else {



          this.setState({ infoText: this.props.language.InerLmt + " " + inner_minplayerbets + " " + this.props.language.MaxInrBetAmt + " " + inner_maxplayerbets })
        }

      }


      else {
        this.setState({ betshigh_balnce: true, attentiobaccart: "Attention!", lowBalaceErrorInfo: `Insufficient Funds to place the BET, Please DEPOSIT to continue playing` })

        if (
          (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
          (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
        ) {


          gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
            { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
          if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {

            this.setState({
              popupbet_errbalncebc: "popupbetshighwindowsbaccart", textbets_highbaccart: "poptextBetshighwindowsbaccart",
              attentionbaccart: "attention_textbaccart", exitbtnbaccart: "exit_popupwndws"
            })
            // popupbetGreaterthanBalnceElement.classList.add("popupbetshighwindowsbaccart");
            // textbetsHighElement.classList.add("poptextBetshighwindowsbaccart");
            // attentionElement.classList.add("attention_textbaccart");

          }
        }
        else {
          const isPortrait = window.innerHeight > window.innerWidth;
          if (isPortrait) {
            gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
              { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
            if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
              // popupbetGreaterthanBalnceElement.classList.add("popupbetshighbaccartport");
              // textbetsHighElement.classList.add("poptextBetshighbaccartport");
              // attentionElement.classList.add("attention_textbaccartport");
              this.setState({
                popupbet_errbalncebc: "popupbetshighbaccartport",
                textbets_highbaccart: "poptextBetshighbaccartport",
                attentionbaccart: "attention_textbaccartport", exitbtnbaccart: "exit_popupbcrtport"
              })

            }

          }
          else {
            gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
              { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
            if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
              // popupbetGreaterthanBalnceElement.classList.add("popupbetshighbaccartland");
              // textbetsHighElement.classList.add("poptextBetshighbaccartland");
              // attentionElement.classList.add("attention_textbaccartland");
              this.setState({
                popupbet_errbalncebc: "popupbetshighbaccartland",
                textbets_highbaccart: "poptextBetshighbaccartland",
                attentionbaccart: "attention_textbaccartland", exitbtnbaccart: "exit_popupbcrtland"
              })

            }

          }
        }
      }
    }
    else {
      this.setState({ betshigh_balnce: true, attentiobaccart: "Attention!", lowBalaceErrorInfo: `Insufficient Funds to place the BET, Please DEPOSIT to continue playing` })

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {


        gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
          { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
        if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {

          this.setState({
            popupbet_errbalncebc: "popupbetshighwindowsbaccart", textbets_highbaccart: "poptextBetshighwindowsbaccart",
            attentionbaccart: "attention_textbaccart", exitbtnbaccart: "exit_popupwndws"
          })
          // popupbetGreaterthanBalnceElement.classList.add("popupbetshighwindowsbaccart");
          // textbetsHighElement.classList.add("poptextBetshighwindowsbaccart");
          // attentionElement.classList.add("attention_textbaccart");

        }
      }
      else {
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) {
          gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
            { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
          if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
            // popupbetGreaterthanBalnceElement.classList.add("popupbetshighbaccartport");
            // textbetsHighElement.classList.add("poptextBetshighbaccartport");
            // attentionElement.classList.add("attention_textbaccartport");
            this.setState({
              popupbet_errbalncebc: "popupbetshighbaccartport",
              textbets_highbaccart: "poptextBetshighbaccartport",
              attentionbaccart: "attention_textbaccartport", exitbtnbaccart: "exit_popupbcrtport"
            })

          }

        }
        else {
          gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
            { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
          if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
            // popupbetGreaterthanBalnceElement.classList.add("popupbetshighbaccartland");
            // textbetsHighElement.classList.add("poptextBetshighbaccartland");
            // attentionElement.classList.add("attention_textbaccartland");
            this.setState({
              popupbet_errbalncebc: "popupbetshighbaccartland",
              textbets_highbaccart: "poptextBetshighbaccartland",
              attentionbaccart: "attention_textbaccartland", exitbtnbaccart: "exit_popupbcrtland"
            })

          }

        }
      }
    }
  }
  BetplaceonBanker = (textrebet) => {
    this.Howlersounds.current?.playSound("pokerchipsnd")
    // alert("..............betonbanker")
    this.hidepayoutbaccart();
    const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_errbalnce");
    const textbetsHighElement = document.getElementById("textbets_highbaccart");
    const attentionElement = document.getElementById("attentionbaccart");

    let chipsbasedonBetbanker = 0;
    let totalbetsonBanker = 0;
    // let totalbetonplayer = this.state.anteBetAmount
    let inner_minbankerbets = this.innerLimits[1][0]
    let inner_maxbankerbets = this.innerLimits[1][1]


    this.newBet = 0;

    const chipDetails = [
      { val: this.chipVal[0].val, src: chip_10, className: "carebeanantechip_10", textclass: "antebet_baccart10" },
      { val: this.chipVal[1].val, src: chip_25, className: "carebeanantechip_20", textclass: "antebet_caribean20" },
      { val: this.chipVal[2].val, src: chip_50, className: "carebeanantechip_50", textclass: "antebet_caribean50" },
      { val: this.chipVal[3].val, src: chip_100, className: "carebeanantechip_100", textclass: "antebet_baccart100" },
      { val: this.chipVal[4].val, src: chip_500, className: "carebeanantechip_500", textclass: "antebet_caribean500" },
      { val: this.chipVal[5].val, src: chip_1000, className: "carebeanantechip_500", textclass: "antebet_caribean500" },
    ];

    const chipData = chipDetails[this.state.count - 1];
    const maxBet = Number(this.props.maxBetAmt);
    let storebaccartgamebets = 0

    if (textrebet === "Rebet" || textrebet === "Rebetx2") {
      const previousBet = Number(this.state.prevstatebanker_bets);
      const newRebet = textrebet === "Rebet" ? previousBet : previousBet * 2;
      if (textrebet === "Rebet") {
        for (let k = 1; k <= this.chipVal.length; k++) {
          if (this.state.count === k) {
            // console.log(this.state.betOnBanker)
            // console.log(Number(this.chipVal[k - 1].val))
            totalbetsonBanker = previousBet;

            chipsbasedonBetbanker = previousBet
          }
        }
        storebaccartgamebets = previousBet
        this.setState({ betOnBanker: storebaccartgamebets })


      }
      else {
        for (let k = 1; k <= this.chipVal.length; k++) {
          if (this.state.count === k) {
            // console.log(this.state.betOnBanker)
            // console.log(Number(this.chipVal[k - 1].val))
            totalbetsonBanker = previousBet * 2;;

            chipsbasedonBetbanker = previousBet * 2;
          }
        }
        storebaccartgamebets = previousBet * 2;

        if (storebaccartgamebets > inner_minbankerbets && storebaccartgamebets <= inner_maxbankerbets) {
          this.setState({ betOnBanker: storebaccartgamebets })

        }
        else {
          this.setState({ betOnBanker: 0 })

        }


      }


    } else {
      if (this.state.betshigh_balnce) {
        this.hidepopup_betshigh();
      }
      for (let k = 1; k <= this.chipVal.length; k++) {
        if (this.state.count === k) {
          // console.log(this.state.betOnBanker)
          // console.log(Number(this.chipVal[k - 1].val))
          totalbetsonBanker = this.state.betOnBanker + Number(this.chipVal[k - 1].val);

          chipsbasedonBetbanker = this.state.betOnBanker + Number(this.chipVal[k - 1].val)
        }


      }

      storebaccartgamebets = this.state.total_betbaccart + Number(chipData.val)

    }

    if (Number(storebaccartgamebets) <= Number(this.props.balance)) {

      if (Number(totalbetsonBanker) <= Number(this.props.balance)) {


        if (Number(totalbetsonBanker) >= Number(inner_minbankerbets) && Number(totalbetsonBanker) <= Number(inner_maxbankerbets)) {

          if (Number(totalbetsonBanker) >= Number(this.props.minBetAmt) && Number(totalbetsonBanker) <= Number(this.props.maxBetAmt) && storebaccartgamebets <= this.props.maxBetAmt) {


            this.buttonsenablebaccart()


            if (textrebet === "Rebet" || textrebet === "Rebetx2") {
              let total_previousbets
              if (this.state.prevstateplayer_bets > 0 || this.state.prevstatebanker_bets > 0 || this.state.prevstatetie_bets > 0) {
                total_previousbets = Number(this.state.prevstateplayer_bets) + Number(this.state.prevstatebanker_bets) + Number(this.state.prevstatetie_bets)
                console.log(Number(this.state.prevstateplayer_bets))
                console.log(Number(this.state.prevstatebanker_bets))
                console.log(Number(this.state.prevstatetie_bets))

              }
              if (textrebet == "Rebet") {

                console.log(this.state.prevstatebanker_bets)
                totalbetsonBanker = this.state.prevstatebanker_bets

                chipsbasedonBetbanker = this.state.prevstatebanker_bets
                // this.setState({total_betbaccart: totalbetsonBanker})
                this.setState({ total_betbaccart: total_previousbets, betdeductbaccart: total_previousbets })
              }
              else {


                let doublebbacrtbets = this.state.prevstatebanker_bets * 2

                totalbetsonBanker = doublebbacrtbets

                chipsbasedonBetbanker = this.state.prevstatebanker_bets * 2
                this.setState({ total_betbaccart: total_previousbets * 2, betdeductbaccart: total_previousbets * 2 })
              }
              // this.setState({total_betbaccart:totalbetsonBanker})
            }

            else {


              this.setState((prevState) => ({
                total_betbaccart: prevState.total_betbaccart + Number(chipData.val),
                betdeductbaccart: prevState.betdeductbaccart + Number(chipData.val)
              }));

            }


            console.log(chipsbasedonBetbanker)
            console.log(totalbetsonBanker)

            // this.setState({isbanker:true,total_betbaccart:totalbetsonBanker})




            let x
            let y

            if (
              (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
              (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
            ) {

              x = -1013
              y = -269

              // setTimeout(() => {
              this.setState({ isbanker: true })

              // }, 100)

              this.BetchipanimPlayerBankerTie("betonBanker", "chiptobankerbaccarat", x, y);

            }
            else {
              const isPortrait = window.innerHeight > window.innerWidth;
              if (isPortrait) {

                // x = 38
                // y = -787
                x = -24
                y = -779
                setTimeout(() => {
                  this.setState({ isbanker: true })

                }, 100)
                this.BetchipanimPlayerBankerTie("betonBanker", "chiptobankerbaccaratport", x, y);


              }
              else {
                x = -1125
                y = 249
                setTimeout(() => {
                  this.setState({ isbanker: true })

                }, 100)
                this.BetchipanimPlayerBankerTie("betonBanker", "chiptobankerbaccaratland", x, y);


              }
            }

            gsap.set(["#betchip_banker img", "#betchip_banker span",], { opacity: 1 });

            if (chipData) {

              document.getElementById("betonBanker").src = chipData.src;

              if (textrebet === "Rebet") {
                this.state.previousBets.banker.push(Number(this.state.prevstatebanker_bets))
                // this.setState({ betOnBanker: this.state.prevstatebanker_bets })
              }
              else if (textrebet === "Rebetx2") {
                let prevstatebankerbets = Number(this.state.prevstatebanker_bets) * 2
                this.state.previousBets.banker.push(prevstatebankerbets)
                // this.setState({ betOnBanker: prevstatebankerbets })

              }

              else {
                this.state.previousBets.banker.push(Number(chipData.val))

                this.setState((prevState) => ({
                  betOnBanker: prevState.betOnBanker + Number(chipData.val)

                }));

              }
            }

            console.log(this.state.previousBets.banker)
            this.state.Bets_tracker.push("B")
            console.log(this.state.Bets_tracker)

            this.setState({
              storeBetchipsbanker: [
                {
                  chip: this.ReturnChipBasedAmount(Number(totalbetsonBanker)),
                  chipvalue: this.topLable_rsp(Number(totalbetsonBanker)),
                  chipcolor1: "valtextPortrait1"
                },

              ],


            })


            this.setState((prevState) => ({
              // totalbet: prevState.totalbet + Number(chipData.val),
              isbaccartbets: true,
              isclear: true,
              isBet: true,
              clearrebet2: true,
              betrebet: true,
              isbetsonpannel: true,

              // prevstatebanker_bets: this.state.betOnBanker

            }));
            console.log(this.state.storeBetchipsbanker)

          }
          else {
            this.setState({ infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl })

          }
        }
        else {

          this.setState({ infoText: this.props.language.InerLmt + " " + inner_minbankerbets + " " + this.props.language.MaxInrBetAmt + " " + inner_maxbankerbets })
        }

      }
      else {
        this.setState({ betshigh_balnce: true, attentiobaccart: "Attention!", lowBalaceErrorInfo: `Insufficient Funds to place the BET, Please DEPOSIT to continue playing` })

        if (
          (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
          (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
        ) {


          gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
            { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
          if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {

            this.setState({
              popupbet_errbalncebc: "popupbetshighwindowsbaccart", textbets_highbaccart: "poptextBetshighwindowsbaccart",
              attentionbaccart: "attention_textbaccart", exitbtnbaccart: "exit_popupwndws"
            })
            // popupbetGreaterthanBalnceElement.classList.add("popupbetshighwindowsbaccart");
            // textbetsHighElement.classList.add("poptextBetshighwindowsbaccart");
            // attentionElement.classList.add("attention_textbaccart");

          }
        }
        else {
          const isPortrait = window.innerHeight > window.innerWidth;
          if (isPortrait) {
            gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
              { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
            if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
              // popupbetGreaterthanBalnceElement.classList.add("popupbetshighbaccartport");
              // textbetsHighElement.classList.add("poptextBetshighbaccartport");
              // attentionElement.classList.add("attention_textbaccartport");
              this.setState({
                popupbet_errbalncebc: "popupbetshighbaccartport",
                textbets_highbaccart: "poptextBetshighbaccartport",
                attentionbaccart: "attention_textbaccartport", exitbtnbaccart: "exit_popupbcrtport"
              })

            }

          }
          else {
            gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
              { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
            if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
              // popupbetGreaterthanBalnceElement.classList.add("popupbetshighbaccartland");
              // textbetsHighElement.classList.add("poptextBetshighbaccartland");
              // attentionElement.classList.add("attention_textbaccartland");
              this.setState({
                popupbet_errbalncebc: "popupbetshighbaccartland",
                textbets_highbaccart: "poptextBetshighbaccartland",
                attentionbaccart: "attention_textbaccartland", exitbtnbaccart: "exit_popupbcrtland"
              })

            }

          }
        }
      }

    }
    else {
      this.setState({ betshigh_balnce: true, attentiobaccart: "Attention!", lowBalaceErrorInfo: `Insufficient Funds to place the BET, Please DEPOSIT to continue playing` })

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {


        gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
          { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
        if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {

          this.setState({
            popupbet_errbalncebc: "popupbetshighwindowsbaccart", textbets_highbaccart: "poptextBetshighwindowsbaccart",
            attentionbaccart: "attention_textbaccart", exitbtnbaccart: "exit_popupwndws"
          })
          // popupbetGreaterthanBalnceElement.classList.add("popupbetshighwindowsbaccart");
          // textbetsHighElement.classList.add("poptextBetshighwindowsbaccart");
          // attentionElement.classList.add("attention_textbaccart");

        }
      }
      else {
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) {
          gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
            { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
          if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
            // popupbetGreaterthanBalnceElement.classList.add("popupbetshighbaccartport");
            // textbetsHighElement.classList.add("poptextBetshighbaccartport");
            // attentionElement.classList.add("attention_textbaccartport");
            this.setState({
              popupbet_errbalncebc: "popupbetshighbaccartport",
              textbets_highbaccart: "poptextBetshighbaccartport",
              attentionbaccart: "attention_textbaccartport", exitbtnbaccart: "exit_popupbcrtport"
            })

          }

        }
        else {
          gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
            { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
          if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
            // popupbetGreaterthanBalnceElement.classList.add("popupbetshighbaccartland");
            // textbetsHighElement.classList.add("poptextBetshighbaccartland");
            // attentionElement.classList.add("attention_textbaccartland");
            this.setState({
              popupbet_errbalncebc: "popupbetshighbaccartland",
              textbets_highbaccart: "poptextBetshighbaccartland",
              attentionbaccart: "attention_textbaccartland", exitbtnbaccart: "exit_popupbcrtland"
            })

          }

        }
      }
    }

  }


  BetPlaceonTie = (textrebet) => {
    this.Howlersounds.current?.playSound("pokerchipsnd")
    this.hidepayoutbaccart();

    const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_errbalnce");
    const textbetsHighElement = document.getElementById("textbets_highbaccart");
    const attentionElement = document.getElementById("attentionbaccart");

    let totalbetsOnTie = 0;
    let chipsbasedonbetOnTie = 0;
    // let totalbetonplayer = this.state.anteBetAmount


    let inner_mintiebets = this.innerLimits[2][0]
    let inner_maxtiebets = this.innerLimits[2][1]
    this.newBet = 0;

    const chipDetails = [
      { val: this.chipVal[0].val, src: chip_10, className: "carebeanantechip_10", textclass: "antebet_baccart10" },
      { val: this.chipVal[1].val, src: chip_25, className: "carebeanantechip_20", textclass: "antebet_caribean20" },
      { val: this.chipVal[2].val, src: chip_50, className: "carebeanantechip_50", textclass: "antebet_caribean50" },
      { val: this.chipVal[3].val, src: chip_100, className: "carebeanantechip_100", textclass: "antebet_baccart100" },
      { val: this.chipVal[4].val, src: chip_500, className: "carebeanantechip_500", textclass: "antebet_caribean500" },
      { val: this.chipVal[5].val, src: chip_1000, className: "carebeanantechip_500", textclass: "antebet_caribean500" },
    ];

    const chipData = chipDetails[this.state.count - 1];
    const maxBet = Number(this.props.maxBetAmt);

    let storebaccartgamebets = 0


    if (textrebet === "Rebet" || textrebet === "Rebetx2") {
      const previousBet = Number(this.state.prevstatetie_bets);

      if (textrebet === "Rebet") {
        for (let k = 1; k <= this.chipVal.length; k++) {
          if (this.state.count === k) {
            // console.log(this.state.betOnBanker)
            // console.log(Number(this.chipVal[k - 1].val))

            totalbetsOnTie = previousBet;
            chipsbasedonbetOnTie = previousBet;

          }
        }
        storebaccartgamebets = previousBet;
        this.setState({ betOnTie: storebaccartgamebets })
      }
      else {
        for (let k = 1; k <= this.chipVal.length; k++) {
          if (this.state.count === k) {
            // console.log(this.state.betOnBanker)
            // console.log(Number(this.chipVal[k - 1].val))
            totalbetsOnTie = previousBet * 2;;

            chipsbasedonbetOnTie = previousBet * 2;
          }
        }
        storebaccartgamebets = previousBet * 2;


        if (storebaccartgamebets > inner_mintiebets && storebaccartgamebets <= inner_maxtiebets) {
          this.setState({ betOnTie: storebaccartgamebets })


        }
        else {
          this.setState({ betOnTie: 0 })

        }

      }

    } else {
      if (this.state.betshigh_balnce) {
        this.hidepopup_betshigh();
      }
      for (let k = 1; k <= this.chipVal.length; k++) {
        if (this.state.count === k) {
          // console.log(this.state.betOnBanker)
          // console.log(Number(this.chipVal[k - 1].val))
          totalbetsOnTie = this.state.betOnTie + Number(this.chipVal[k - 1].val);

          chipsbasedonbetOnTie = this.state.betOnTie + Number(this.chipVal[k - 1].val)
        }

      }
      storebaccartgamebets = this.state.total_betbaccart + Number(chipData.val)
    }





    // alert('..............'+newBet)

    // console.log(newBet)
    console.log(this.roundNumber)
    console.log(Number(chipData.val))
    // this.setState({totalbets_baccart:newBet})

    // alert('..............'+newBet)

    console.log(this.state.total_betbaccart)

    if (Number(storebaccartgamebets) <= Number(this.props.balance)) {
      if (Number(totalbetsOnTie) <= Number(this.props.balance)) {

        if (Number(totalbetsOnTie) >= Number(inner_mintiebets) && Number(totalbetsOnTie) <= Number(inner_maxtiebets)) {

          if (Number(totalbetsOnTie) >= Number(this.props.minBetAmt) && Number(totalbetsOnTie) <= Number(this.props.maxBetAmt) && storebaccartgamebets <= this.props.maxBetAmt) {




            if (this.props.balance >= 0) {
              this.buttonsenablebaccart()
              this.betchipstoantebet = document.getElementById(this.state.chipid);


              if (textrebet === "Rebet" || textrebet === "Rebetx2") {

                let total_previousbets
                if (this.state.prevstateplayer_bets > 0 || this.state.prevstatebanker_bets > 0 || this.state.prevstatetie_bets > 0) {
                  total_previousbets = Number(this.state.prevstateplayer_bets) + Number(this.state.prevstatebanker_bets) + Number(this.state.prevstatetie_bets)
                  console.log(Number(this.state.prevstateplayer_bets))
                  console.log(Number(this.state.prevstatebanker_bets))
                  console.log(Number(this.state.prevstatetie_bets))

                }


                if (textrebet == "Rebet") {

                  console.log(this.state.prevstatetie_bets)
                  totalbetsOnTie = this.state.prevstatetie_bets
                  // this.setState({total_betbaccart:totalbetsOnTie})
                  this.setState({ total_betbaccart: total_previousbets, betdeductbaccart: total_previousbets })
                }
                else {


                  let doublebbacrtbets = this.state.prevstatetie_bets * 2

                  totalbetsOnTie = doublebbacrtbets
                  // this.setState({total_betbaccart: doublebbacrtbets})
                  this.setState({ total_betbaccart: total_previousbets * 2, betdeductbaccart: total_previousbets * 2 })
                }
              }
              else {
                // for (let k = 1; k <= this.chipVal.length; k++) {
                //   if (this.state.count === k) {
                //     // console.log(this.state.betOnBanker)
                //     console.log(Number(this.chipVal[k - 1].val))
                //     totalbetsOnTie = this.state.betOnTie + Number(this.chipVal[k - 1].val);

                //     chipsbasedonbetOnTie = this.state.betOnTie + Number(this.chipVal[k - 1].val)
                //   }
                // }

                this.setState((prevState) => ({
                  total_betbaccart: prevState.total_betbaccart + Number(chipData.val),
                  betdeductbaccart: prevState.betdeductbaccart + Number(chipData.val),
                }));
              }

              this.setState({ betsting_tie: totalbetsOnTie })

              let x
              let y

              if (

                (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
                (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
              ) {


                x = -1016
                y = -430
                // setTimeout(() => {
                //   this.setState({ isTie: true }, () => {
                //     this.BetchipanimPlayerBankerTie("betonTie", "chipstotie", x, y)
                //     })
                // }, 350)
                // setTimeout(() => {
                //   this.setState({ isTie: true })
                // }, 200)
                // this.BetchipanimPlayerBankerTie("betonTie", "chipstotie", x, y)


                // setTimeout(() => {
                //   this.setState({ isTie: true })

                // }, 100)

                this.BetchipanimPlayerBankerTie("betonTie", "chipstotie", x, y);
                setTimeout(() => {
                  this.setState({ isTie: true })

                }, 100)

              }
              else {
                const isPortrait = window.innerHeight > window.innerWidth;
                if (isPortrait) {

                  // x = 19
                  // y = -1052
                  x = -21
                  y = -1060
                  setTimeout(() => {
                    this.setState({ isTie: true })

                  }, 100)
                  this.BetchipanimPlayerBankerTie("betonTie", "chipstotieport", x, y)

                }
                else {
                  x = -1133
                  y = 19
                  setTimeout(() => {
                    this.setState({ isTie: true })

                  }, 100)
                  this.BetchipanimPlayerBankerTie("betonTie", "chipstotieland", x, y)


                }
              }
              gsap.set(["#betsto_tie img", "#betsto_tie span",], { opacity: 1 });

              // const chipData = chipDetails[this.state.count - 1];

              if (chipData) {
                document.getElementById("betonTie").src = chipData.src;

                if (textrebet === "Rebet") {
                  this.state.previousBets.tie.push(Number(this.state.prevstatetie_bets))
                  // this.setState({ betOnTie: this.state.prevstatetie_bets })

                }

                else if (textrebet === "Rebetx2") {
                  let prevstatetiebets = Number(this.state.prevstatetie_bets) * 2
                  this.state.previousBets.tie.push(prevstatetiebets)
                  // this.setState({ betOnTie: prevstatetiebets })

                }

                else {
                  this.state.previousBets.tie.push(Number(chipData.val))
                  this.setState((prevState) => ({

                    betOnTie: prevState.betOnTie + Number(chipData.val),

                  }));


                }
              }
              this.state.Bets_tracker.push("T")
              console.log(this.state.Bets_tracker)

              this.setState({
                storeBetchipstie: [
                  {
                    chip: this.ReturnChipBasedAmount(Number(totalbetsOnTie)),
                    // chipvalue: this.topLable_rsp(Number(totalbetsOnTie.toFixed(2))),
                    chipvalue: this.topLable_rsp(Number(totalbetsOnTie)),
                    chipcolor1: "valtextPortrait1"
                  },

                ],

              })



              this.setState((prevState) => ({
                // totalbet: prevState.totalbet + Number(chipData.val),

                isbaccartbets: true,
                isclear: true,
                isBet: true,
                clearrebet2: true,
                betrebet: true,

                isbetsonpannel: true,

                // prevstatetie_bets: this.state.betOnTie
              }));
            }
          }
          else {
            this.setState({ infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl })

          }

        }

        else {

          this.setState({ infoText: this.props.language.InerLmt + " " + inner_mintiebets + " " + this.props.language.MaxInrBetAmt + " " + inner_maxtiebets })

        }
      }


      else {
        this.setState({ betshigh_balnce: true, attentiobaccart: "Attention!", lowBalaceErrorInfo: `Insufficient Funds to place the BET, Please DEPOSIT to continue playing` })

        if (

          (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
          (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
        ) {


          gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
            { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
          if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {

            this.setState({
              popupbet_errbalncebc: "popupbetshighwindowsbaccart", textbets_highbaccart: "poptextBetshighwindowsbaccart",
              attentionbaccart: "attention_textbaccart", exitbtnbaccart: "exit_popupwndws"
            })
            // popupbetGreaterthanBalnceElement.classList.add("popupbetshighwindowsbaccart");
            // textbetsHighElement.classList.add("poptextBetshighwindowsbaccart");
            // attentionElement.classList.add("attention_textbaccart");

          }
        }
        else {
          const isPortrait = window.innerHeight > window.innerWidth;
          if (isPortrait) {
            gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
              { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
            if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
              // popupbetGreaterthanBalnceElement.classList.add("popupbetshighbaccartport");
              // textbetsHighElement.classList.add("poptextBetshighbaccartport");
              // attentionElement.classList.add("attention_textbaccartport");
              this.setState({
                popupbet_errbalncebc: "popupbetshighbaccartport",
                textbets_highbaccart: "poptextBetshighbaccartport",
                attentionbaccart: "attention_textbaccartport", exitbtnbaccart: "exit_popupbcrtport"
              })

            }

          }
          else {
            gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
              { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
            if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
              // popupbetGreaterthanBalnceElement.classList.add("popupbetshighbaccartland");
              // textbetsHighElement.classList.add("poptextBetshighbaccartland");
              // attentionElement.classList.add("attention_textbaccartland");
              this.setState({
                popupbet_errbalncebc: "popupbetshighbaccartland",
                textbets_highbaccart: "poptextBetshighbaccartland",
                attentionbaccart: "attention_textbaccartland", exitbtnbaccart: "exit_popupbcrtland"
              })

            }

          }
        }
      }
    }
    else {
      this.setState({ betshigh_balnce: true, attentiobaccart: "Attention!", lowBalaceErrorInfo: `Insufficient Funds to place the BET, Please DEPOSIT to continue playing` })

      if (

        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {


        gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
          { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
        if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {

          this.setState({
            popupbet_errbalncebc: "popupbetshighwindowsbaccart", textbets_highbaccart: "poptextBetshighwindowsbaccart",
            attentionbaccart: "attention_textbaccart", exitbtnbaccart: "exit_popupwndws"
          })
          // popupbetGreaterthanBalnceElement.classList.add("popupbetshighwindowsbaccart");
          // textbetsHighElement.classList.add("poptextBetshighwindowsbaccart");
          // attentionElement.classList.add("attention_textbaccart");

        }
      }
      else {
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) {
          gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
            { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
          if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
            // popupbetGreaterthanBalnceElement.classList.add("popupbetshighbaccartport");
            // textbetsHighElement.classList.add("poptextBetshighbaccartport");
            // attentionElement.classList.add("attention_textbaccartport");
            this.setState({
              popupbet_errbalncebc: "popupbetshighbaccartport",
              textbets_highbaccart: "poptextBetshighbaccartport",
              attentionbaccart: "attention_textbaccartport", exitbtnbaccart: "exit_popupbcrtport"
            })

          }

        }
        else {
          gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
            { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
          if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
            // popupbetGreaterthanBalnceElement.classList.add("popupbetshighbaccartland");
            // textbetsHighElement.classList.add("poptextBetshighbaccartland");
            // attentionElement.classList.add("attention_textbaccartland");
            this.setState({
              popupbet_errbalncebc: "popupbetshighbaccartland",
              textbets_highbaccart: "poptextBetshighbaccartland",
              attentionbaccart: "attention_textbaccartland", exitbtnbaccart: "exit_popupbcrtland"
            })

          }

        }
      }
    }
  }


  BetchipanimPlayerBankerTie = (chipid, chipclassname, xvalue, yvalue) => {


    if (this.state.isoptionmenu === true) {
      this.Showoptionsmenu();
    }
    this.cardsRef.current.ReBet();
    this.dealerCardsContainer.current.ReBet();
    this.setState({
      playerscore: "",
      bankerscore: "",
      scoreplyrbnker: "",
      playerscoretext: "",
      bankerscoretext: "",
      totalwinamountbaccart: 0,
      iswinsbaccart: false,

    })

    console.log(chipclassname)
    console.log(chipid)
    console.log(xvalue)
    console.log(yvalue)
    const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_errbalnce");
    const textbetsHighElement = document.getElementById("textbets_highbaccart");
    const attentionElement = document.getElementById("attentionbaccart");

    if (this.props.balance >= 0) {

      const betchipstoantebet = document.getElementById(chipid);
      console.log(betchipstoantebet)
      const betchipstoantebetchip = document.getElementById("baccaratchip");

      // if (
      //   navigator.userAgentData &&
      //   navigator.userAgentData.platform &&
      //   navigator.userAgentData.platform == "Windows"
      // ) {
      this.setState({ carebbeanbetchipstoante: chipclassname, infoText: this.props.language.BET_Game, enebleprevbuttons: false })

      betchipstoantebet.classList.add(this.state.carebbeanbetchipstoante)


      var tl = gsap.timeline();
      tl.to(betchipstoantebet, {
        x: xvalue,
        y: yvalue,
        duration: 0.1,
        ease: "power2.inOut",
        opacity: 1,
        zIndex: 12,
        onComplete: () => {
          gsap.set(betchipstoantebet, { opacity: 0 });
        }
      });
      tl.to(betchipstoantebet, {
        opacity: 0,
        x: -4,
        duration: 0.1,
        y: 6,
        zIndex: -2
      });



    }
    else {

      this.setState({

        infoText: this.props.language.Place_antebet,

      })


    }



    // }


    // else{
    //   const isPortrait = window.innerHeight > window.innerWidth;
    //   if (isPortrait) {


    //   }
    //   else{



    //   }


    // }


  }




  showAnteBetchips = () => {
    // alert('...........antechips')
    console.log(this.state.storeantebetchips)
    let playerbetchips
    let textplayerchip

    if (

      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

      playerbetchips = "chipbasedonvaluewindows"
      textplayerchip = "chipvaluebaccarat"
    }
    else {

      const isPortrait = window.innerHeight > window.innerWidth;
      if (isPortrait) {
        playerbetchips = "chipbasedonvalueport"
        textplayerchip = "chipvaluebaccaratport"
      }
      else {
        playerbetchips = "chipbasedonvalueland"
        textplayerchip = "chipvaluebaccaratland"

      }

    }

    return (

      this.state.storeantebetchips.map((eachchip, index) => (
        <div key={index} id="chipcenterposition" className={`${this.state.antebetpdvcss}`}>

          <img
            // className={`${this.state.antechpimgcss}`}
            className={`${playerbetchips}`}
            src={eachchip.chip}
            alt="Chip"
          />
          <span

            className={`${textplayerchip}`}
          // className={`${eachchip.chipcolor1} ${this.state.antespntxtcss}`} 
          >{eachchip.chipvalue}</span>
        </div>
      ))

    )


  }
  BeetChiptoBanker = () => {
    let bankerbetchips
    let textbankerchip
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

      bankerbetchips = "chipstobankerbaccart"
      textbankerchip = "chipvaluebaccaratbankr"
    }
    else {
      const isPortrait = window.innerHeight > window.innerWidth;
      if (isPortrait) {
        bankerbetchips = "chipstobankerbaccartport"
        textbankerchip = "chipvaluebaccaratbankrport"
      }
      else {
        bankerbetchips = "chipstobankerbaccartland"
        textbankerchip = "chipvaluebaccaratbankrland"

      }
    }

    console.log(this.state.storeantebetchips)

    return (
      this.state.storeBetchipsbanker.map((eachchip, index) => (
        <div id="betchip_banker">
          <img
            // className={`${this.state.antechpimgcss}`}
            className={`${bankerbetchips}`}
            src={eachchip.chip}
            alt="Chip"
          />
          <span
            className={`${textbankerchip}`}
          // className={`${eachchip.chipcolor1} ${this.state.antespntxtcss}`} 
          >{eachchip.chipvalue}</span>
        </div>
      ))
    )

  }
  BeetChiptoTie = () => {

    let tiebetchips
    let texttiechip
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {

      tiebetchips = "chipstoTie_baccart"
      texttiechip = "chipvalueontie"
    }
    else {
      const isPortrait = window.innerHeight > window.innerWidth;
      if (isPortrait) {
        tiebetchips = "chipstoTie_baccartport"
        texttiechip = "chipvalueontieport"
      }
      else {
        tiebetchips = "chipstoTie_baccartland"
        texttiechip = "chipvalueontieland"

      }
    }


    console.log(this.state.storeantebetchips)

    return (
      this.state.storeBetchipstie.map((eachchip, index) => (
        <div id="betsto_tie">
          <img
            // className={`${this.state.antechpimgcss}`}
            className={`${tiebetchips}`}
            src={eachchip.chip}
          // alt="Chip"
          />
          <span
            className={`${texttiechip}`}
          // className={`${eachchip.chipcolor1} ${this.state.antespntxtcss}`} 
          >{eachchip.chipvalue}</span>
        </div>
      ))
    )
  }

  updateplayerbalnace = () => {


    this.props.gamstateHandle();
    // this.setState({betdeductions:0,noupdateblnce:true})
    const body2 = {
      CN: "GET_PLAYER_INFO",
      object: {
        gameId: Number(this.props.gameId,),
        playerId: Number(this.props.playerId),

      },
      sessionId: sessionStorage.getItem('sessionId'),
    }
    this.props.network.sendof(body2);
    this.body2 = {};

  }

  BetResponcebaccart = (res) => {
    let windwsplfx
    let windwsplfy
    let windwsplbx
    let windwsplby

    let winaninbkfx
    let winaninbkfy
    let winaninbkbx
    let winaninbkby


    let winanintiefx
    let winanintiefy
    let winanintiebx
    let winanintieby
    // this.setState({ betshigh_balnce: true})
    this.setState(
      {
        displayplayerscporepercard: res.playerCardScores,
        displaybankerscporepercard: res.dealerCardScores,
      },
      () => {


      }
    );


    console.log(this.state.displayplayerscporepercard)
    // this.state.displayplayerscporepercard.map((i,val)=>{
    //   setInterval(()=>{
    // this.setState({playerscore:val})
    //   },500)
    //  this.setState({playerscore:val})

    // })




    if (res.winAmount > 0) {
      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        switch (res.message) {
          case "Player":
            windwsplfx = -416
            windwsplfy = -349
            windwsplbx = 3
            windwsplby = 1

            winaninbkfx = 10
            winaninbkfy = -940
            winaninbkbx = 5
            winaninbkby = 1

            winanintiefx = 10
            winanintiefy = -773
            winanintiebx = 1
            winanintieby = 1
            break;
          case "Banker":


            winaninbkfx = 467
            winaninbkfy = -182
            winaninbkbx = 5
            winaninbkby = 1


            windwsplfx = 10
            windwsplfy = -1090
            windwsplbx = 3
            windwsplby = 1


            winanintiefx = 10
            winanintiefy = -773
            winanintiebx = 1
            winanintieby = 1
            break;
          case "Tie":



            winanintiefx = -6
            winanintiefy = -189
            winanintiebx = 1
            winanintieby = 1

            windwsplfx = 10
            windwsplfy = -1090
            windwsplbx = 3
            windwsplby = 1

            winaninbkfx = 10
            winaninbkfy = -940
            winaninbkbx = 5
            winaninbkby = 1



            break;
          default:
            break;
        }



      }
      else {
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) {
          // this.setState({ scoreplyrbnker: "displyscoreport" })

          switch (res.message) {
            case "Player":

              windwsplfx = -401
              windwsplfy = -507
              windwsplbx = 3
              windwsplby = 1


              winaninbkfx = 10
              winaninbkfy = -1740
              winaninbkbx = 5
              winaninbkby = 1

              winanintiefx = 10
              winanintiefy = -1573
              winanintiebx = 1
              winanintieby = 1


              break;
            case "Banker":



              winaninbkfx = 424
              winaninbkfy = -297
              winaninbkbx = 5
              winaninbkby = 1

              windwsplfx = 10
              windwsplfy = -2590
              windwsplbx = 3
              windwsplby = 1


              winanintiefx = 10
              winanintiefy = -1573
              winanintiebx = 1
              winanintieby = 1

              break;
            case "Tie":


              windwsplfx = 10
              windwsplfy = -2590
              windwsplbx = 3
              windwsplby = 1

              winaninbkfx = 10
              winaninbkfy = -1740
              winaninbkbx = 5
              winaninbkby = 1


              winanintiefx = 10
              winanintiefy = -285
              winanintiebx = 1
              winanintieby = 1
              break;
            default:
              break;
          }


        }
        else {
          // this.setState({ scoreplyrbnker: "displyscoreland" })
          switch (res.message) {
            case "Player":
              windwsplfx = -806
              windwsplfy = -468
              windwsplbx = 5
              windwsplby = -3




              winaninbkfx = 10
              winaninbkfy = -1740
              winaninbkbx = 5
              winaninbkby = 1

              winanintiefx = 10
              winanintiefy = -1573
              winanintiebx = 1
              winanintieby = 1

              break;

            case "Banker":


              windwsplfx = 10
              windwsplfy = -2590
              windwsplbx = 3
              windwsplby = 1


              winanintiefx = 10
              winanintiefy = -1573
              winanintiebx = 1
              winanintieby = 1


              winaninbkfx = 806
              winaninbkfy = -277
              winaninbkbx = 4
              winaninbkby = 0


              break;
            case "Tie":
              windwsplfx = 10
              windwsplfy = -2590
              windwsplbx = 3
              windwsplby = 1

              winaninbkfx = 10
              winaninbkfy = -1740
              winaninbkbx = 5
              winaninbkby = 1


              winanintiefx = 10
              winanintiefy = -201
              winanintiebx = 0
              winanintieby = -1



              break;
            default:
              break;
          }


        }

      }
    }
    else {
      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        switch (res.message) {
          case "Player":
          case "Banker":
          case "Tie":
            windwsplfx = 10
            windwsplfy = -1090
            windwsplbx = 3
            windwsplby = 1



            winaninbkfx = 10
            winaninbkfy = -940
            winaninbkbx = 5
            winaninbkby = 1

            winanintiefx = 10
            winanintiefy = -773
            winanintiebx = 1
            winanintieby = 1
            break;
          default:
            break;
        }
      }
      else {
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) {
          switch (res.message) {
            case "Player":
            case "Banker":
            case "Tie":
              windwsplfx = 10
              windwsplfy = -2590
              windwsplbx = 3
              windwsplby = 1

              winaninbkfx = 10
              winaninbkfy = -1740
              winaninbkbx = 5
              winaninbkby = 1

              winanintiefx = 10
              winanintiefy = -1573
              winanintiebx = 1
              winanintieby = 1
              break;
            default:
              break;
          }
        }
        else {
          switch (res.message) {
            case "Player":
            case "Banker":
            case "Tie":
              windwsplfx = 10
              windwsplfy = -2590
              windwsplbx = 3
              windwsplby = 1

              winaninbkfx = 10
              winaninbkfy = -1740
              winaninbkbx = 5
              winaninbkby = 1

              winanintiefx = 10
              winanintiefy = -1573
              winanintiebx = 1
              winanintieby = 1
              break;
            default:
              break;
          }

        }

      }


    }
    document.getElementById("playerDealerCardContainer").style.zIndex = -1



    // alert("...........1")
    console.log(res)

    this.randomPlayerCards = [...res.playerCards];



    this.randomDealerCards = [...res.bankerCards];


    console.log("this.randomDealerCards", this.randomDealerCards);
    console.log("this.randomPlayerCards", this.randomPlayerCards);

    let cnt = this.randomPlayerCards.length;

    const playerCards = this.randomPlayerCards;
    const dealerCards = this.randomDealerCards;

    const playerCardNames = ["cardZero", "cardOne", "cardTwo", "cardThree", "cardFour"];
    const dealerCardNames = ["cardZero", "cardOne", "cardTwo", "cardThree"];

    const maxCards = Math.max(playerCards.length, dealerCards.length);
    const delayStep = 500;


    const delaySteparray = 250;

    console.log(playerCards)
    console.log(res.playerCardScores)

    for (let i = 0; i < maxCards; i++) {

      if (i < playerCards.length) {
        const b1 = playerCards[i];
        setTimeout(() => {
          this.cardsRef.current.addCards(playerCardNames[i], b1, playerCards.length);

        }, i * delayStep * 2);
      }



      if (i < dealerCards.length) {
        const a1 = dealerCards[i];
        setTimeout(() => {
          this.dealerCardsContainer.current.addCards(dealerCardNames[i], a1, dealerCards.length);

        }, i * delayStep * 2 + delayStep);
      }

    }







    setTimeout(() => {
      this.startPlayerScoreAnimation(res.playerCardScores);

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {
        this.setState({ scoreplyrbnker: "displyscorewindows", playerscoretext: "playerscoretextwind", bankerscoretext: "bankerscoretextwind" })
      }
      else {
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) {
          this.setState({ scoreplyrbnker: "displyscoreport", playerscoretext: "playerscoretextport", bankerscoretext: "bankerscoretextport" })
        }
        else {
          this.setState({ scoreplyrbnker: "displyscoreland", playerscoretext: "playerscoretextland", bankerscoretext: "bankerscoretextland" })

        }

      }

    }, 1000)
    setTimeout(() => {
      this.startbankerScoreAnimation(res.dealerCardScores);
    }, 1700)

    setTimeout(() => {


      const positions = {
        Player: {
          player: { forward: { x: windwsplfx, y: windwsplfy }, backward: { x: windwsplbx, y: windwsplby } },
          banker: { forward: { x: winaninbkfx, y: winaninbkfy }, backward: { x: winaninbkbx, y: winaninbkby } },
          tie: { forward: { x: winanintiefx, y: winanintiefy }, backward: { x: winanintiebx, y: winanintieby } },
        },
        Banker: {
          player: { forward: { x: windwsplfx, y: windwsplfy }, backward: { x: windwsplbx, y: windwsplby } },
          banker: { forward: { x: winaninbkfx, y: winaninbkfy }, backward: { x: winaninbkbx, y: winaninbkby } },
          tie: { forward: { x: winanintiefx, y: winanintiefy }, backward: { x: winanintiebx, y: winanintieby } },
        },

        Tie: {
          player: { forward: { x: windwsplfx, y: windwsplfy }, backward: { x: windwsplbx, y: windwsplby } },
          banker: { forward: { x: winaninbkfx, y: winaninbkfy }, backward: { x: winaninbkbx, y: winaninbkby } },
          tie: { forward: { x: winanintiefx, y: winanintiefy }, backward: { x: winanintiebx, y: winanintieby } },
        },
      };

      const winnerPositions = positions[res.message];
      console.log(winnerPositions)
      if (winnerPositions) {


        this.ChipanimationBasedplayerdealertiewins(winnerPositions, res);
      }
      // this.setState({ winner: res.message, })



      this.setState({ finalwinnerpopup: false })

    }, 5000)
  }


  startPlayerScoreAnimation = (cards) => {
    let index = 0;
    let total = 0;

    const showCardValue = () => {
      if (index < cards.length) {
        const currentValue = cards[index];
        total += currentValue;

        this.setState((prevState) => ({
          playerscore: currentValue
        }));

        index++;
        setTimeout(showCardValue, 1200);
      } else {
        const finalScore = total % 10;
        // setTimeout(() => {
        this.setState((prevState) => ({
          playerscore: finalScore
        }));
        // }, 620);
      }
    };

    showCardValue();
  };


  startbankerScoreAnimation = () => {
    const cards = [...this.state.displaybankerscporepercard];
    let index = 0;
    let total = 0;

    this.setState({ bankerscore: null });

    const showCardValue = () => {
      if (index < cards.length) {
        const currentValue = cards[index];
        total += currentValue;

        this.setState({ bankerscore: currentValue });

        index++;


        setTimeout(showCardValue, 1100);
      } else {

        // setTimeout(() => {
        const finalScore = total % 10;
        this.setState({ bankerscore: finalScore });
        // }, 500);
      }
    };

    showCardValue();
  };






  ChipanimationBasedplayerdealertiewins = (animvalues, res) => {

    console.log(animvalues)
    this.setState({ finalwinnerpopup: false })

    let t2 = gsap.timeline()


    t2.to('#chipcenterposition img , #chipcenterposition span', {
      x: animvalues.player.forward.x,
      y: animvalues.player.forward.y,
      opacity: 1,
      duration: 0.5,
      ease: 'power2.out'
    }).to('#chipcenterposition img , #chipcenterposition span', {
      delay: 3,
      x: animvalues.player.backward.x,
      y: animvalues.player.backward.y,
      opacity: 1,
      duration: 0.5,
      opacity: 0,
      ease: 'power2.out',
      onComplete: () => {
        gsap.set('#chipcenterposition img , #chipcenterposition span', { opacity: 0 });
      }
    });

    let tl = gsap.timeline();
    tl.to('#betchip_banker img , #betchip_banker span', {
      x: animvalues.banker.forward.x,
      y: animvalues.banker.forward.y,
      opacity: 1,
      duration: 0.5,
      delay: 1.5,
      ease: 'power2.out'
    }).to('#betchip_banker img , #betchip_banker span', {
      delay: 3,
      x: animvalues.banker.backward.x,
      y: animvalues.banker.backward.y,
      opacity: 1,
      duration: 0.5,
      opacity: 0,
      ease: 'power2.out',
      onComplete: () => {
        gsap.set('#betchip_banker img, #betchip_banker span', { opacity: 0 });
      }
    });

    let t3 = gsap.timeline();
    t3.to('#betsto_tie img, #betsto_tie span', {
      x: animvalues.tie.forward.x,
      y: animvalues.tie.forward.y,
      opacity: 1,
      delay: 1,
      duration: 0.5,
      ease: 'power2.out'
    }).to('#betsto_tie img, #betsto_tie span', {
      delay: 3,
      x: animvalues.tie.backward.x,
      y: animvalues.tie.backward.y,
      opacity: 1,
      duration: 0.5,
      opacity: 0,
      ease: 'power2.out',
      onComplete: () => {
        gsap.set('#betsto_tie img, #betsto_tie span', { opacity: 0 });
      }
    });



    setTimeout(() => {
      if (res.message === "Player") {
        this.setState({
          storeantebetchips: [
            {
              chip: this.ReturnChipBasedAmountUndo(Number(res.winAmount)),
              chipvalue: this.topLable_rsp(Number(res.winAmount)),
              chipcolor1: "valtextPortrait1"
            },

          ],
        })
      }
      if (res.message === "Banker") {
        this.setState({
          storeBetchipsbanker: [
            {
              chip: this.ReturnChipBasedAmountUndo(Number(res.winAmount)),
              // chipvalue: this.topLable_rsp(Number(totalAnteBetAmountbanker.toFixed(2))),
              chipvalue: this.topLable_rsp(Number(res.winAmount)),
              chipcolor1: "valtextPortrait1"
            },

          ],
        })

      }
      if (res.message === "Tie") {


        this.setState({
          storeBetchipstie: [
            {
              chip: this.ReturnChipBasedAmountUndo(Number(res.winAmount)),
              chipvalue: this.topLable_rsp(Number(res.winAmount)),
              chipcolor1: "valtextPortrait1"
            },

          ],



        })
      }
    }, 2000)




    setTimeout(() => {
      this.setState({ finalwinner: true, winner: res.message })
      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {
        this.setState({ winglowbaccart: "winglowbaccartanim" })


      }
      else {
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) {
          this.setState({
            winglowbaccart: "winglowbaccartanimport"
          })

        }
        else {
          this.setState({
            winglowbaccart: "winglowbaccartanland"


          })
        }

      }
    }, 1500)


    setTimeout(() => {
      this.setState({
        finalwinnerpopup: true, finalwinner: false,
        winglowbaccart: ""
      })

      if (res.winAmount > 0) {

        this.setState({
          showWinAnimation: true,
          showwinanimbaccarat: true,
          totalwinamountbaccart: res.winAmount,
          iswinsbaccart: true,
          isbaccarat: true,
        })

        this.Howlersounds.current?.playSound("playerWin")

        if (document.getElementById('winPopbcrt')) {
          document.getElementById('winPopbcrt').style.display = 'block';
        };


        // if (
        //   navigator.userAgentData &&
        //   navigator.userAgentData.platform &&
        //   navigator.userAgentData.platform == "Windows" || (navigator.userAgent.indexOf("Windows") !== -1)
        // ) {

        //   // if (res.message === "Player") {
        //   //   this.setState({
        //   //     glowpopbaccart: "chipglow_baccartplayer",

        //   //     winamountbaccart: "winamt_baccartwinplayer",
        //   //   })

        //   // }
        //   // if (res.message === "Banker") {
        //   //   this.setState({
        //   //     glowpopbaccart: "chipglow_baccartbanker",

        //   //     winamountbaccart: "winamt_baccartwinbanker",
        //   //   })

        //   // }
        //   // if (res.message === "Tie") {
        //   //   this.setState({
        //   //     glowpopbaccart: "chipglow_baccarttie",

        //   //     winamountbaccart: "winamt_baccartwintie",
        //   //   })

        //   // }
        //   if (document.getElementById('winPopbcrt')) {
        //     document.getElementById('winPopbcrt').style.display = 'block';
        //   };

        // }
        // else {
        //   const isPortrait = window.innerHeight > window.innerWidth;
        //   if (isPortrait) {



        //     // if (res.message === "Player") {
        //     //   this.setState({
        //     //     glowpopbaccart: "chipglow_baccartportplayer",

        //     //     winamountbaccart: "winamt_baccartport",
        //     //   })

        //     }
        //     // if (res.message === "Banker") {
        //     //   this.setState({
        //     //     glowpopbaccart: "chipglow_baccartportbanker",

        //     //     winamountbaccart: "winamt_baccartport",
        //     //   })

        //     }
        //     // if (res.message === "Tie") {
        //     //   this.setState({
        //     //     glowpopbaccart: "chipglow_baccartporttie",

        //     //     winamountbaccart: "winamt_baccartport",
        //     //   })

        //     // }
        //   }
        //   else {
        //     // if (res.message === "Player") {
        //     // this.setState({
        //     //   glowpopbaccart: "chipglow_baccartland",
        //     //   winamountbaccart: "winamt_baccartland",
        //     // })

        //     // }

        //     // if (res.message === "Player") {
        //     //   this.setState({
        //     //     glowpopbaccart: "chipglow_baccartlandplayer",

        //     //     winamountbaccart: "winamt_baccartland",
        //     //   })

        //     // }
        //     // if (res.message === "Banker") {
        //     //   this.setState({
        //     //     glowpopbaccart: "chipglow_baccartlandbanker",

        //     //     winamountbaccart: "winamt_baccartland",
        //     //   })

        //     // }
        //     // if (res.message === "Tie") {
        //     //   this.setState({
        //     //     glowpopbaccart: "chipglow_baccartlandtie",

        //     //     winamountbaccart: "winamt_baccartland",
        //     //   })

        //     // }
        //   }


      }

      // }
      else {
        this.setState({
          totalwinamountbaccart: res.winAmount,
          iswinsbaccart: false
        })
        // this.playRemainingSounds(this.playerWin)
        this.setState({
          // glowpopbaccart: "",
          // winamountbaccart: "",
        })
      }


    }, 2500)




    setTimeout(() => {
      // this.setState({ finalwinner: true })

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {

        // if(res.message==="Player"){
        //   this.setState({ glowpopbaccart: "chipglow_baccart",
        //     winamountbaccart: "winamt_baccart",})

        // }
        this.setState({
          isbanker: false, isplayer: false,
          isTie: false,
          // clerbtn_baccarat: true,
          // beticonbaccart: true,
          // isclear: false,
          // isBet: false,



          // bettext_baccart: "Bettext_Baccarat",
          // cleartext_baccart: "Cleartext_Baccarat",



        })

      }
      else {
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) {

          // if(res.message==="Player"){
          //   this.setState({ glowpopbaccart: "chipglow_baccartport",
          //     winamountbaccart: "winamt_baccartport",})

          // }

          this.setState({
            isbanker: false, isplayer: false,
            isTie: false,
            // clerbtn_baccarat: true,
            // beticonbaccart: true,
            scoreplyrbnker: "displyscoreport",
            playerscoretext: "playerscoretextport",
            bankerscoretext: "bankerscoretextport"

            // bettext_baccart: "Bettext_Baccaratport",
            // cleartext_baccart: "Cleartext_Baccaratport"

          })

        }
        else {
          // if(res.message==="Player"){
          //   this.setState({ glowpopbaccart: "chipglow_baccart",
          //     winamountbaccart: "winamt_baccart",})

          // }

          this.setState({
            isbanker: false, isplayer: false,
            isTie: false,
            // clerbtn_baccarat: true,
            // beticonbaccart: true,
            scoreplyrbnker: "displyscoreland",
            playerscoretext: "playerscoretextland",
            bankerscoretext: "bankerscoretextland",


            anteBetAmount: 0,
            betOnBanker: 0,
            betOnTie: 0

          })
        }

      }
      this.setState({ enebleprevbuttons: true })

      this.updateplayerbalnace();
      this.updatedplayerinfoBaccarat();


      let betstring = res.betString

      let finalbets = betstring.split("|")
      console.log(finalbets)
      let player_betsbaccarat = finalbets[0]
      let bankerbets = finalbets[1]
      let tiebets = finalbets[2]
      console.log(player_betsbaccarat)
      console.log(bankerbets)
      console.log(tiebets)
      this.setState({ prevstateplayer_bets: player_betsbaccarat, prevstatebanker_bets: bankerbets, prevstatetie_bets: tiebets })

    }, 2500)
    setTimeout(() => {
      if (document.getElementById('winPopbcrt')) {
        document.getElementById('winPopbcrt').style.display = 'none';
      };
    }, 6000);




  }
  updatedplayerinfoBaccarat = () => {

    this.props.gamstateHandle();
    // this.setState({betdeductions:0,noupdateblnce:true})
    const body2 = {
      CN: "GET_UPDATED_PLAYER_INFO",
      object: {
        gameId: Number(this.props.gameId,),
        playerId: Number(this.props.playerId),

      },
      sessionId: sessionStorage.getItem('sessionId'),
    }
    this.props.network.sendof(body2);
    this.body2 = {};


  }

  UpdateplayerinfoPlayerWins() {
    if (this.state.totalwinamountbaccart > 0) {

      setTimeout(() => {

        if (this.props.gameState.response) {
          if (this.props.gameState.response.betAmount > 0) {


            this.setState({ enebleprevbuttons: true })
            setTimeout(() => {

              this.enableprevbetsbuttons(this.props.gameState.response.betString);
            }, 1300)
          }
        }

        this.setState({ lowBalaceErrorInfo: "" })
        this.clearActivesWeDid();
      }, 3000)


    }
    else {


      setTimeout(() => {

        if (this.props.gameState.response) {
          if (this.props.gameState.response.betAmount > 0) {


            this.setState({ enebleprevbuttons: true })
            setTimeout(() => {

              this.enableprevbetsbuttons(this.props.gameState.response.betString);
            }, 1300)
          }
        }

        this.setState({ lowBalaceErrorInfo: "" })
        this.clearActivesWeDid();

      }, 1000)



    }

  }
  clearActivesWeDid = () => {

    if (this.state.isoptionmenu === true) {
      this.Showoptionsmenu();
    }

    // this.setState({
    //   bsbtn: true
    // });

    this.randomPlayerCards = [];
    this.shuffledPlayerCards = [];
    this.randomDealerCards = [];


    // setTimeout(() => {
    setTimeout(() => {

      // this.setState({ betpannelcover_baccart: "", })

    }, 1000)
    this.setState({
      storeantebetchips: [],
      storeBetchipsbanker: [],
      storeBetchipstie: [],
      // playerscore: "",
      infoText: this.props.language.baccart_bet,
      total_betbaccart: 0,
      totalwinamountbaccart: 0,
      // bankerscore: "",
      // scoreplyrbnker: "",

      // glowpopbaccart: "",
      winner: "",
      finalwinner: false,
      isPannelEnabled: true,

      finalwinnerpopup: false,


      winamountbaccart: "",

      Bets_tracker: [],

      betOnTie: 0,
      betOnBanker: 0,
      anteBetAmount: 0,
      winglowbaccart: "",
      showWinAnimation: false,
      showwinanimbaccarat: false,
      isbaccarat: false,
      isclear: false,
      isBet: false,

      isbetsonpannel: false,

      previousBets: {
        player: [], banker: [], tie: []
      },

    })


    this.setState({ betdeductbaccart: 0 })


    // }, 2500)
    setTimeout(() => {
      this.setState({
        popupbet_errbalncebc: "", textbets_highbaccart: "",
        attentionbaccart: "", exitbtnbaccart: "",
        attentiobaccart: "",
      })

    }, 500)



  }


  disablebaccartbuttons = () => {
    this.setState({
      beticonbaccart: false, bettext_baccart: "", undotex_baccarat: "",
      cleartext_baccart: "", undobtn_baccart: false, clerbtn_baccarat: false, isbetsonpannel: false,
      clearrebet2: false,
      betrebet: false,
    })

  }
  BaccartBets = () => {
    this.Howlersounds.current?.playSound("pokerchipsnd")
    if (this.state.isoptionmenu === true) {
      this.Showoptionsmenu();
    }

    // this.setState({isplayer:false,isbanker:false,isTie:false})
    this.hidepayoutbaccart();
    this.hidepopup_betshigh();
    if (this.state.total_betbaccart >= this.props.minBetAmt && this.state.total_betbaccart <= this.props.maxBetAmt) {

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {
        this.setState({ betpannelcover_baccart: "coverbaccart_windows" })


      }
      else {
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) {
          this.setState({ betpannelcover_baccart: "coverbaccart_port" })
        }
        else {



          this.setState({ betpannelcover_baccart: "coverbaccart_land" })
        }

      }
      this.disablebaccartbuttons();

      document.getElementById("playerDealerCardContainer").style.zIndex = 20;
      const { anteBetAmount, betOnBanker, betOnTie } = this.state

      let baccart_betstring = `${anteBetAmount.toFixed(1)}|${betOnBanker.toFixed(1)}|${betOnTie.toFixed(1)}`
      console.log(baccart_betstring)

      const body = {
        sessionId: sessionStorage.getItem("sessionId"),

        CN: "BACCARAT_BET",
        object: {

          gameId: this.props.gameId,
          playerId: Number(this.props.playerId),
          betAmount: Number(this.state.total_betbaccart).toFixed(2),
          betString: baccart_betstring,
          handId: Number(this.props.gameState.handId)
        },
      };
      this.props.network.sendof(body);
      this.setState({
        infoText: "",
        clearrebet2: false,
        betrebet: false,
        isPannelEnabled: false,
      })

    }
    else {
      this.setState({ infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl })

    }








  }



  Clearbets_baccart = () => {
    this.Howlersounds.current?.playSound("clearSnd")

    this.hidepayoutbaccart();

    this.hidepopup_betshigh();

    this.setState({ clearrebet2: false, betrebet: false })
    this.clearActivesWeDid();
    let positions
    if (
      (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
      (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
    ) {
      this.setState({ betpannelcover_baccart: "coverbaccart_windows" })
      positions = {
        animationchips: {
          chipsplayer: { forward: { x: 995, y: 124 }, backward: { x: 3, y: 1 } },
          chipsbanker: { forward: { x: 1000, y: 272 }, backward: { x: 5, y: 1 } },
          chipstie: { forward: { x: 995, y: 439 }, backward: { x: 1, y: 1 } },
        },

      };



    }

    else {
      const isPortrait = window.innerHeight > window.innerWidth;
      if (isPortrait) {
        this.setState({ betpannelcover_baccart: "coverbaccart_port" })
        positions = {
          animationchips: {
            chipsplayer: { forward: { x: -28, y: 519 }, backward: { x: 3, y: 1 } },
            chipsbanker: { forward: { x: -32, y: 756 }, backward: { x: 5, y: 1 } },
            chipstie: { forward: { x: 10, y: 1047 }, backward: { x: 1, y: 1 } },
          },

        };

      }
      else {
        this.setState({ betpannelcover_baccart: "coverbaccart_land" })
        positions = {
          animationchips: {
            chipsplayer: { forward: { x: 1125, y: -441 }, backward: { x: 3, y: 1 } },
            chipsbanker: { forward: { x: 1134, y: -239 }, backward: { x: 5, y: 1 } },
            chipstie: { forward: { x: 1116, y: 4 }, backward: { x: 1, y: 1 } },
          },

        };
      }
    }
    this.setState({
      anteBetAmount: 0,
      betOnBanker: 0,
      betOnTie: 0,
    })
    setTimeout(() => {
      this.setState({
        betpannelcover_baccart: "",
        // storeantebetchips: [],
        // storeBetchipsbanker: [],
        // storeBetchipstie: [],
      })

    }, 1200)

    this.disablebaccartbuttons();


    let t2 = gsap.timeline()
    t2.to('#chipcenterposition img,#chipcenterposition span ', {
      x: positions.animationchips.chipsplayer.forward.x, y: positions.animationchips.chipsplayer.forward.y, opacity: 1, opacity: 0, duration: .3, ease: 'power2.out',
      onComplete: () => {
        gsap.set('#chipcenterposition img ', { opacity: 0 })
      }
    });
    t2.to('#chipcenterposition img,#chipcenterposition span ', {
      x: positions.animationchips.chipsplayer.backward.x, y: positions.animationchips.chipsplayer.backward.y, opacity: 1, duration: .1, opacity: 0, ease: 'power2.out',
      onComplete: () => {
        gsap.set('#chipcenterposition img ', { opacity: 0 })
      }
    });


    let tl = gsap.timeline()
    tl.to('#betchip_banker img ,#betchip_banker span', {
      x: positions.animationchips.chipsbanker.forward.x, y: positions.animationchips.chipsbanker.forward.y, opacity: 1, duration: .3, ease: 'power2.out', opacity: 0,
      onComplete: () => {
        gsap.set('#betchip_banker img ', { opacity: 0 })
      }
    });
    tl.to('#betchip_banker img ,#betchip_banker span', {
      x: positions.animationchips.chipsbanker.backward.x, y: positions.animationchips.chipsbanker.backward.y, opacity: 1, duration: .1, opacity: 0, ease: 'power2.out',
      onComplete: () => {
        gsap.set('#betchip_banker img ', { opacity: 0 })
      }
    });




    let t3 = gsap.timeline()
    t3.to('#betsto_tie img,#betsto_tie span ', {
      x: positions.animationchips.chipstie.forward.x, y: positions.animationchips.chipstie.forward.y, opacity: 1, duration: .3, ease: 'power2.out', opacity: 0,
      onComplete: () => {
        gsap.set('#betsto_tie img ', { opacity: 0 })
      }
    });
    t3.to('#betsto_tie img,#betsto_tie span ', {
      x: positions.animationchips.chipstie.backward.x, y: positions.animationchips.chipstie.backward.y, opacity: 1, duration: .1, opacity: 0, ease: 'power2.out',
      onComplete: () => {
        gsap.set('#betsto_tie img ', { opacity: 0 })
      }
    });

    // setTimeout(() => {
    this.setState({ isbanker: false, isplayer: false, isTie: false })
    // }, 1500)
    setTimeout(() => {

      this.setState({ total_betbaccart: 0, betdeductbaccart: 0 })

    }, 1000)
  }


  Prevsiousbaccartbetas = (bettext) => {
    //   +"..............."+this.state.prevstatetie_bets
    // )

    const popupbetGreaterthanBalnceElement = document.getElementById("popupbet_errbalnce");
    const textbetsHighElement = document.getElementById("textbets_highbaccart");
    const attentionElement = document.getElementById("attentionbaccart");




    const newRebet = bettext === "Rebet" ? 1 : 2;


    if (this.props.balance < this.props.gameState.response.betAmount * newRebet) {

      this.setState({ betshigh_balnce: true, attentiobaccart: "Attention!", lowBalaceErrorInfo: `Insufficient Funds to place the BET, Please DEPOSIT to continue playing` })

      if (
        (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
        (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0))
      ) {


        gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
          { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
        if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {

          this.setState({
            popupbet_errbalncebc: "popupbetshighwindowsbaccart", textbets_highbaccart: "poptextBetshighwindowsbaccart",
            attentionbaccart: "attention_textbaccart", exitbtnbaccart: "exit_popupwndws"
          })
          // popupbetGreaterthanBalnceElement.classList.add("popupbetshighwindowsbaccart");
          // textbetsHighElement.classList.add("poptextBetshighwindowsbaccart");
          // attentionElement.classList.add("attention_textbaccart");

        }
      }
      else {
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) {
          gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
            { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
          if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
            // popupbetGreaterthanBalnceElement.classList.add("popupbetshighbaccartport");
            // textbetsHighElement.classList.add("poptextBetshighbaccartport");
            // attentionElement.classList.add("attention_textbaccartport");
            this.setState({
              popupbet_errbalncebc: "popupbetshighbaccartport",
              textbets_highbaccart: "poptextBetshighbaccartport",
              attentionbaccart: "attention_textbaccartport", exitbtnbaccart: "exit_popupbcrtport"
            })

          }

        }
        else {
          gsap.fromTo(popupbetGreaterthanBalnceElement, { scale: 0, rotate: 0, opacity: 0 },
            { scale: 1, duration: 1, rotate: 720, opacity: 1, ease: "power2.out" });
          if (popupbetGreaterthanBalnceElement && textbetsHighElement && attentionElement) {
            // popupbetGreaterthanBalnceElement.classList.add("popupbetshighbaccartland");
            // textbetsHighElement.classList.add("poptextBetshighbaccartland");
            // attentionElement.classList.add("attention_textbaccartland");
            this.setState({
              popupbet_errbalncebc: "popupbetshighbaccartland",
              textbets_highbaccart: "poptextBetshighbaccartland",
              attentionbaccart: "attention_textbaccartland", exitbtnbaccart: "exit_popupbcrtland"
            })

          }

        }
      }

    } else {


      // }
      if (this.state.prevstateplayer_bets > 0) {

        // alert("..............2")

        // setTimeout(()=>{
        //   this.setState({ isplayer: true })

        // },300)
        let Textrebet = bettext

        this.BetplaceonPlayer(Textrebet);
      }
      if (this.state.prevstatebanker_bets > 0) {
        // alert("..............3")
        // setTimeout(()=>{
        //   this.setState({ isbanker: true })

        // },300)

        this.BetplaceonBanker(bettext);

      }
      if (this.state.prevstatetie_bets > 0) {

        // setTimeout(()=>{
        //   this.setState({ isTie: true })

        // },300)
        this.BetPlaceonTie(bettext);
      }

    }




  }
  handleImageLoad = () => {
    const { assestsLoaderFunction } = this.props;
    assestsLoaderFunction()
  }
  // addglow=()=>{
  //   alert("....landscape")
  //   this.setState({player_glow:true,playeractive:"PlayerPannel_glowland"})
  // }
  hidemenupayout = () => {
    if (this.state.isoptionmenu === true) {
      //  this.Showoptionsmenu();
    }

  }
  closeWin() {
    document.getElementById('iospopup').style.display = "none";


  }
  render() {
    console.log(this.props.baccartpayoutin)
    console.log(this.state.Bets_tracker)


    this.roundNumber = this.props.balance - this.state.betdeductbaccart


    console.log(this.state.betdeductbaccart)
    console.log(this.roundNumber)
    console.log(this.state.betdeductbaccart)
    this.betAmount = (this.roundNumber)
    let balance_baccart = Number(this.betAmount.toFixed(2));
    // console.log(balance_rsp)
    let updateBet = Number(this.state.total_betbaccart.toFixed(2));
    let popup_winamount = this.topLable_rsp(this.state.totalwinamountbaccart)
    console.log(this.state.betactvglwcss)
    const {
      heightOfLayer,
      widthOfLayer,
      dealerDistanceFromX,
      playerDistanceFromX,
      dealerPlayerDistanceFromY,
      isMobilePortraitLndsp,
      dealerDistanceFromY,
      PlayerDistanceFromY,
    } = this.state;
    console.log(window.innerWidth);
    console.log(window.innerHeight);



    return (
      <Fragment>
        <div id="Baccart_bgport" className={this.state.bgbaccartport} alt="Baccarat Table"> </div>
        <div id="Baccart_Table" className={this.state.Baccarattable} alt="Baccarat Table" onClick={(e) => { e.preventDefault(); this.hidemenupayout(); }} >
          <img src={this.tableImg} alt="Hidden Loader" className="hidden" onLoad={this.handleImageLoad} />
          <div id="Baccart_topsection" className={this.state.topsection_Baccarat}>
            <img src={optionbtnwindows} className={this.state.optionbtnwindows} onClick={(e) => { e.preventDefault(); this.Showoptionsmenu(); }} />
            <img src={useridlmg} id="user_baccaticon" className={this.state.usericonbaccart} />
            <img id="balanceiconwindows" src={balanceiconwindows} className={this.state.balance_baccarticn} />
            <img id="beticonwindows" src={beticonwindows} className={this.state.bet__iconbaccart} />
            <img src={winnericnwindows} className={this.state.winner_iconbaccart} />
          </div>
          <span id="baccart_user" className={this.state.userbaccart}>{this.props.user}</span>
          <span className={this.state.balncebaccart}>{balance_baccart}</span>
          <span className={this.state.totlbetbaccart}>{updateBet}</span>
          <span className={this.state.winamount_baccart}>{this.state.iswinsbaccart ? this.state.totalwinamountbaccart : 0}</span>

          {this.state.isbanker ? (this.BeetChiptoBanker()) : ""}
          {this.state.isplayer ? (this.showAnteBetchips()) : ""}
          {this.state.isTie ? (this.BeetChiptoTie()) : ""}
          <div id="sound_infromicons" className={this.state.volume_infrmcontainer}>
            <img id="volume_baccarat" src={volume_baccart} onClick={(e) => { e.preventDefault(); this.muteunmutesounds(); }} />
            <img id="Inform_baccarat" src={infrmicon_baccart} onClick={(e) => { e.preventDefault(); this.Showpayouttable(); }} />
          </div>
          <div className={this.state.winglowbaccart}>
            <span>{this.state.finalwinner ? this.state.winner : ""}</span>
          </div>
          <div id="betpannel_baccarat" className={this.state.baccaratbetpannel} >
            <img id="Tie" src={Tiepannel} className={this.state.TiePannel} onClick={(e) => { e.preventDefault(); this.state.isPannelEnabled && this.BetPlaceonTie(); }} />
            <img id="Banker" src={Banker_pannel} className={this.state.BankerPannel} onClick={(e) => { e.preventDefault(); this.state.isPannelEnabled && this.BetplaceonBanker(); }} />

            <img src="" ref={this.chiprefBaccart} id="baccartbets" className={this.state.carebbeanbetchipstoante} draggable={false} />
            <img src="" ref={this.chiprefbanker} id="betonBanker" className={this.state.carebbeanbetchipstoante} draggable={false} />
            <img src="" ref={this.chiprefTie} id="betonTie" className={this.state.carebbeanbetchipstoante} draggable={false} />
            <img id="baccaratchip" src="" />
            <div>  {this.state.storebetchips} </div>
            <div id="Player" className="player-pannel">
              <img src={Player_pannel} onClick={(e) => { e.preventDefault(); this.state.isPannelEnabled && this.BetplaceonPlayer(); }} className={this.state.PlayerPannel} draggable={false} />
            </div>
          </div>

          <div id="playerDetailscrbn" className={this.state.phanddetails_baccarat}>
            <span>P ID: {this.props.playerId}</span>
            <span>ID: {this.props.gameState.handId}</span>
          </div>

          <div id="undobtn">
            <button type="button" onClick={(e) => { this.state.isBet ? this.Clearbets_baccart() : this.Prevsiousbaccartbetas("Rebetx2") }}>
              {/* <img src={this.state.clerbtn_baccarat ? clear_baccartimg : ""} id="clearbets_baccart"  */}
              {/* className={this.state.clerbuttontn_baccarat} /> */}
              {this.state.clerbtn_baccarat && (<img
                src={clear_baccartimg}

                className={this.state.clerbuttontn_baccarat}

              />)}


              {this.state.clearrebet2 ? <span id="undotext" className={this.state.cleartext_baccart}>{this.state.isclear ? this.props.language.RP_Clear : this.props.language.RebetX2}</span> : ""}


            </button>
          </div>

          <button type="button" onClick={(e) => { this.state.isBet ? this.BaccartBets() : this.Prevsiousbaccartbetas("Rebet") }}>
            {/* <img
              src={this.state.beticonbaccart ? betbutton_baccartimg : ""}
              className={this.state.betbutton_baccart}
              alt=""
            /> */}
            {this.state.beticonbaccart && (
              <img
                src={betbutton_baccartimg}

                className={this.state.betbutton_baccart}

              />
            )}

            {this.state.betrebet ? <span className={this.state.bettext_baccart}>{this.state.isBet ? this.props.language.Bet : this.props.language.Rebet}</span> : ""}

          </button>
          <button type="button" onClick={(e) => { e.preventDefault(); this.Undobetscaribbean(); }}>
            {/* <img src={this.state.undobtn_baccart ? undobuttonbaccart : ""} id="undo_baccart" className={this.state.undotextcss_baccart} /> */}
            {/* <span id="undotext" className={this.state.undotex_baccarat}>{this.state.undobtn_baccart ? this.props.language.Undo : null}</span> */}
            {this.state.undobtn_baccart && (
              <img
                src={undobuttonbaccart}
                id="undo_baccart"
                className={this.state.undotextcss_baccart}
                alt="undo button"
              />
            )}
            <span id="undotext" className={this.state.undotex_baccarat}>{this.state.undobtn_baccart ? this.props.language.Undo : null}</span>

          </button>



          <div id="btns_incrementdecrement" className={this.state.incredecrebtns} onClick={(e) => { e.preventDefault(); this.hidepayoutbaccart(); }}>
            <button disabled={this.state.betdecreamentbtn}>
              <img src={decrementbtn} id="betdecrementcrbn"
                onClick={(e) => { e.preventDefault(); this.DecreamentBetchips(); }} alt="" />
            </button>
            <button disabled={this.state.betchipincrementbtn}>
              <img src={incerementbtn} id="betincrenetcrbn" onClick={(e) => { e.preventDefault(); this.IncreamentBetchips(); }} alt="" />
            </button>
          </div>
          <div id="betchipsbaccarat_Container" className={this.state.baccaratchipscontainer}>
            {this.chipVal.map((obj, i) => (
              <div>
                <img src="" id="betchipsbaccart" alt="" className={this.state.chipsbaccart} />
                <span key={i}
                  className={this.state.chipsbaccartval}

                  id={`val${i}`}></span>
              </div>

            ))}
          </div>

          <img src="" id="Russianbgwindows" onClick={(e) => { e.preventDefault(); this.hidepopup_betshigh() }} />

          {this.state.isoptionmenu ? (
            <div id="optionsmenubutton" className={this.state.optionsmenubutton}>

              <div id="buttontscontainer">
                <button id="limitscrbn" onClick={(e) => {
                  e.preventDefault();
                  this.ShowLimits();
                }}>LIMITS</button>
                <button id="help_crbn" onClick={(e) => {
                  e.preventDefault();
                  this.Gamerules();
                }}>HELP</button>
                <button id="historytext_bcrt" onClick={(e) => {
                  e.preventDefault();
                  this.ShowHistory()
                }}>HISTORY</button>


              </div>
            </div>
          ) : (
            ""
          )}

          {this.state.ShowGamerules ? (
            <div id="ShowGamerulescrbn">
              <h1 id="gameruleMainHeadingbaccarat">GAME RULES</h1>
              <ul id="unorderedlistitemsbaccart">

                <hr id="hrline" />
                {this.GameRules.map((val, key) => (
                  <li>{val.name}</li>
                ))}
              </ul>

            </div>

          ) : ""}



          <div className="player-dealer-card-containerbcrt" id="playerDealerCardContainer" onClick={(e) => { e.preventDefault(); this.hidepayoutbaccart() }}>
            <Stage width={widthOfLayer} height={heightOfLayer}
              style={{ width: `${widthOfLayer}px`, height: `${heightOfLayer}px` }}
              pixelRatio={1}
            >
              <Layer>
                <Group x={dealerDistanceFromX} y={dealerDistanceFromY} stroke="black">
                  <DealerCardsContainer ref={this.dealerCardsContainer} x={450} y={400} xPadding={18}
                    scaleX={this.state.scaleX} scaleY={this.state.scaleY}
                    isMobilePortrait={isMobilePortraitLndsp} activeScreen={this.state.activeScreen} mutesounds={this.state.mutesounds} />
                </Group>
                <Group x={playerDistanceFromX} y={PlayerDistanceFromY} stroke="black">
                  <Card ref={this.cardsRef} x={450} y={400} xPadding={18} previousGamestateCardLength6={this.props.previousGamestateCardLength6}
                    scaleX={this.state.scaleX} scaleY={this.state.scaleY}
                    ratioed={1} hidecardPos={30} numberOfCardsToBeDraw={this.numberOfCardsToBeDraw}
                    isMobilePortrait={isMobilePortraitLndsp} mutesounds={this.state.mutesounds} activeScreen={this.state.activeScreen} />
                </Group>
              </Layer>

            </Stage>
          </div>
          <div id="betpannelcarebbeancover"></div>
          <div id="mobileAntiMaskCover_crbn" className={this.state.mobileAntiMaskCovercss}></div>


          <div id="PokerDeckcrbn">
            <img id="crbndeck" src="" />
          </div>

          {this.state.ShowLimits ? (
            <div id="limitscrbnpopup">
              <span>MinBet: {this.props.minBetAmt}</span>
              <span>MaxBet: {this.props.maxBetAmt}</span>

              <span>InnerLimits: {`${this.innerLimits[0][0]} - ${this.innerLimits[0][1]}`}</span>

              {/* <button id="exitLimits" onClick={(e) => {
              e.preventDefault();
              this.exitLimits()
            }}
            // onMouseOver={() => this.animexit()}
            >EXIT</button> */}
            </div>
          ) : ""}


          <div className={this.state.scoreplyrbnker}>
            <span className={this.state.playerscoretext} id="playerScoreDisplay">{this.state.playerscore !== null ? this.state.playerscore : ''}</span>
            <span className={this.state.bankerscoretext} >{this.state.bankerscore}</span>
          </div>

          <div id="winpopup_baccart" className={this.state.glowpopbaccart}>
            <span id="winamt_baccart" className={this.state.winamountbaccart}>
              {/* {this.state.finalwinnerpopup ? popup_winamount : ""} */}
            </span>
          </div>
          <div className={this.state.betpannelcover_baccart}>
          </div>



          {this.state.ShowHistory ? (
            <div id="prevhistory_crbn" className={this.state.baccart_history}>
              <table id="histry_russian_bacacrt">
                <thead id="heading_hstiry_baccart">
                  <tr>
                    <th rowSpan="2">Hand Id</th>
                    <th rowSpan="2">Banker Cards</th>
                    <th rowSpan="2">Banker score</th>
                    <th rowSpan="2">Player Cards</th>
                    <th rowSpan="2">Player score</th>
                    <th colSpan="2">Player</th>
                    <th colSpan="2">Banker</th>
                    <th colSpan="2">Tie</th>
                    <th rowSpan="2">Winner</th>

                  </tr>
                  <tr>
                    <th>Bet</th>
                    <th>Win</th>
                    <th>Bet</th>
                    <th>Win</th>
                    <th>Bet</th>
                    <th>Win</th>
                  </tr>
                </thead>
                <tbody id="histry_body_bcrt">
                  {(this.props.gameState.history && Array.isArray(this.props.gameState.history)
                    ? this.props.gameState.history
                    : []
                  ).map((obj, i) => {
                    const [playerbets, bankerbets, tiebets] = obj.result?.betString?.split("|") || [];

                    return (
                      <tr key={`card-${i}`} id={`${i}`}>
                        <td>{obj.result?.handId || '-'}</td>

                        <td>
                          {obj.result?.bankerCards?.map((card_num, index) => {
                            const matchingCard = resultCards_crbn.find(res => res.rsc_val === card_num);
                            return (
                              <img
                                className="cardsimages_bcrt"
                                key={index}
                                src={matchingCard ? matchingCard.src : ''}
                                alt={card_num || 'Card'}
                              />
                            );
                          })}
                        </td>

                        <td>{obj.result?.bankerScore || 0}</td>

                        <td>
                          {obj.result?.playerCards?.map((card_num, index) => {
                            const matchingCard = resultCards_crbn.find(res => res.rsc_val === card_num);
                            return (
                              <img
                                className="cardsimages_bcrt"
                                key={index}
                                src={matchingCard ? matchingCard.src : ''}
                                alt={card_num || 'Card'}
                              />
                            );
                          })}
                        </td>

                        <td>{obj.result?.playerScore || 0}</td>

                        <td>{playerbets ?? 0}</td>
                        <td>{obj.result.message === "Player" ? obj.result.winAmount : 0}</td>
                        <td>{bankerbets ?? 0}</td>
                        <td>{obj.result.message === "Banker" ? obj.result.winAmount : 0}</td>
                        <td>{tiebets ?? 0}</td>
                        {/* <td>{this.state.tie_wins ?? 0}</td> */}
                        <td>{obj.result.message === "Tie" ? obj.result.winAmount : 0}</td>
                        <td>{obj.result.message}</td>
                      </tr>
                    );
                  })}
                </tbody>

              </table>

            </div>
          ) : null}
          <div id="infocontainerbaccart" className={this.state.infobaccart}>
            <span id="info_baccart" >{this.state.infoText}</span>
          </div>


          <div id="minmaxbetbaccart" className={this.state.baccartminmax_bets}>
            <span>MinBet: {this.props.minBetAmt}</span>
            <span>MaxBet: {this.props.maxBetAmt}</span>

          </div>


          {this.state.showpayouts ? (
            <div id="PAYOUTTABLE" className={this.state.paytablebcrt}>
              <table id="Payout_crbn">
                <thead id="heading_payout" className={this.state.payout_mainhead}>
                  <tr>
                    <th>PayOut Info</th>

                  </tr>
                </thead>

                <tbody id="payout_bodybaccart" className={this.state.payout_bodyubaccrt}>
                  {this.props.baccartpayoutin.map((obj, i) => (
                    <tr key={`card-${i}`} id={`${i}`}>
                      <td id="playerhand">

                        {obj.key}
                      </td>
                      <td id="playerwinamount">{obj.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          ) : null}
          <img src={baccartdeck} className={this.state.baccartdeckcards} />


        </div>
        <div id="popupbet_errbalnce" className={this.state.popupbet_errbalncebc}>
          {(this.state.betshigh_balnce !== null) &&
            <button className={this.state.exitbtnbaccart} id="exit_popupcrbn" onClick={this.hidepopup_betshigh}><img src={popupExit} alt={popupExit} /></button>
          }
          <span id="textbets_highbaccart" className={this.state.textbets_highbaccart}>
            <h4 id="attentionbaccart" className={this.state.attentionbaccart}>{this.state.attentiobaccart}</h4>
            {this.state.lowBalaceErrorInfo}
          </span>



        </div>

        <div className="winPopAmrcRltbcrt" id="winPopbcrt">
          <div className="popBorderbcrt">
            {this.props.language.Win_Amt} &nbsp;
            <span> {popup_winamount} </span>
          </div>
        </div>
        {this.state.showwinanimbaccarat &&
          (<WinAnimation showWinAnimation={this.state.showWinAnimation} amount={popup_winamount} isbaccaratgame={true} />)}


        <div className="iosFetchSounds" id="iospopup" onClick={(e) => this.closeWin()}>
          <div className="popupTooLong">
            <div className=""> {this.props.language.Wel_BC}</div>
            <br></br>
            {this.props.language.OK_Btn}
            <br></br>
            <br></br>
            <div className="fd">
              <button className="btn_iosPopup" > OK </button>
              <br></br>
            </div>
          </div>
        </div>
        <Howlersounds ref={this.Howlersounds} mutesounds={this.state.mutesounds} />
      </Fragment>
    );
  }

}



const mapStatesToProps = (state) => {
  return {
    language: state.languageObjs.languageObj
  }
}

export default connect(mapStatesToProps)(Baccarat)


